<template>
  <div>
    <template v-if="show">
      <b-sidebar
        id="sidebar-right"
        title="Шинэ"
        right
        shadow
        backdrop
        v-model="showSidebar"
        :width="wd"
        @change="visibleChanged"
        :no-close-on-backdrop="true"
        :no-close-on-route-change="true"
        no-header-close
        header-class="pd-0-f wd-100p core-edit-side-header"
      >
        <template v-slot:title>
          <nav class="navbar bd-b d-flex">
            <span>Шинэ</span>

            <button
              class="btn btn-xs btn-uppercase mg-l-auto btn-danger"
              @click="visibleChanged(false)"
            >
              <!-- <feather type="x" class="mg-r-5"></feather> -->
              Хаах
            </button>
          </nav>
        </template>

        <div v-if="ready">
          <div class="container bg-white ht-100p bd-l bd-r">
            <task-edit
              :prms.sync="taskEdit"
              :show.sync="taskEdit.show"
              @on-edit-close="editClosed"
              @on-task-posted="taskPosted"
            ></task-edit>
            <b-overlay :show="datahandleLoading" rounded="sm">
              <div v-show="currentTab == 1">
                <Form
                  ref="formValidate"
                  :model="taskModel"
                  label-width="30%"
                  :label-position="labelPosition"
                >
                  <template
                    v-if="
                      ($store.state.app.activeGroup.id == 9241 ||
                        $store.state.app.activeGroup.id == 9249) &&
                        (prms.objectTypeId == 115 || prms.objectTypeId == 396)
                    "
                  >
                    <FormItem label="ERP">
                      <Select
                        v-model="erpGolomt.curValue"
                        filterable
                        clearable
                        @change="erpCourseSourceChanged"
                        class="wd-100p"
                      >
                        <Option
                          :value="
                            prms.objectTypeId == 115
                              ? c.trainingId
                              : c.teacherId
                          "
                          :label="
                            prms.objectTypeId == 115
                              ? c.trainingName
                              : c.teacherName
                          "
                          :key="c.trainingId"
                          v-for="c in erpGolomt.sources"
                        ></Option>
                      </Select>
                    </FormItem>
                  </template>
                  <template
                    v-for="(field, i) in fields.filter((x) =>
                      hiddenFields ? x.editOrd < otConfig.editViewType : true
                    )"
                  >
                    <!-- {{field.field}} {{field.flag}} -->

                    <div
                      v-if="
                        field.helpInfo != undefined &&
                          field.helpInfo != null &&
                          field.helpInfo != ''
                      "
                      v-html="field.helpInfo"
                    ></div>
                    <template v-if="field.flag === 0">
                      <!-- reserved server tald utga hadgalsan -->
                    </template>
                    <template v-else-if="field.flag === 1">
                      <FormItem v-if="isFieldShow(field)"
                        :rules="field.rule"
                        :label="field.title"
                        :prop="field.field"
                        :key="`lbl_${i}`"
                      >
                        <Input
                          v-if="field.maxlength > 0"
                          :placeholder="field.info"
                          v-model="$data['taskModel'][field.field]"
                          :maxlength="field.maxlength"
                        />
                        <Input
                          v-else
                          :placeholder="field.info"
                          v-model="$data['taskModel'][field.field]"
                        />
                      </FormItem>
                      
                    </template>
                    <template v-else-if="field.flag === 2">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <Input
                          v-if="field.maxlength > 0"
                          v-model="$data['taskModel'][field.field]"
                          type="textarea"
                          placeholder="..."
                          :maxlength="field.maxlength"
                        />
                        <Input
                          v-else
                          v-model="$data['taskModel'][field.field]"
                          type="textarea"
                          placeholder="..."
                        />
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag == 3">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        v-show="isFieldShow(field)"
                      >
                        <loc-type-cascader
                          :id.sync="$data['taskModel'][field.field]"
                          v-model="$data['taskModel'][field.field]"
                          :getParentType="true"
                          :checkStrictly="true"
                          :locTypekey.sync="field.key"
                          :disabled="
                            (taskModel.objectTypeId == 411 &&
                              taskModel.id != 0) ||
                              taskModel.objectTypeId == 533
                          "
                          :taskModel="taskModel"
                        />
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag == 5">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <input
                          type="checkbox"
                          v-model="$data['taskModel'][field.field]"
                        />
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 6">
                      <template v-if="taskModel.objectTypeId === 60">
                        <template v-if="taskModel.flag1 === 9900">
                          <FormItem
                            v-if="[field.field] != 'dueStartDate'"
                            :label="field.title"
                            :prop="field.field"
                            :key="`lbl_${i}`"
                            :rules="field.rule"
                          >
                            <DatePicker
                              v-model="$data['taskModel'][field.field]"
                              placeholder="Огноо сонгоно уу"
                              type="datetime"
                              style="width: 100%"
                              :format="'yyyy-MM-dd HH:mm:ss'"
                              :value-format="'yyyy-MM-dd HH:mm:ss'"
                            ></DatePicker>
                            <div class="text-muted tx-11 eddt-title-info">
                              {{ infoBuilder(field.info) }}
                            </div>
                          </FormItem>
                        </template>
                        <FormItem
                          v-else
                          :label="field.title"
                          :prop="field.field"
                          :key="`lbl_${i}`"
                          :rules="field.rule"
                        >
                          <DatePicker
                            v-model="$data['taskModel'][field.field]"
                            placeholder="Огноо сонгоно уу"
                            type="datetime"
                            :format="'yyyy-MM-dd HH:mm:ss'"
                            :value-format="'yyyy-MM-dd HH:mm:ss'"
                            style="width: 100%"
                          ></DatePicker>
                          <div class="text-muted tx-11 eddt-title-info">
                            {{ infoBuilder(field.info) }}
                          </div>
                        </FormItem>
                      </template>
                      <FormItem
                        v-else
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                      >
                        <!-- :value-format="'yyyy-MM-dd HH:mm:ss'" -->
                        <!-- <DatePicker
                          v-model="$data['taskModel'][field.field]"
                          placeholder="Огноо сонгоно уу"
                          type="datetime"
                          style="width: 100%"
                          :format="'yyyy-MM-dd HH:mm:ss'"
                          :value-format="'yyyy-MM-dd HH:mm:ss'"
                        ></DatePicker> -->
                        <VueCtkDateTimePicker
                          locale="mn"
                          v-model="$data['taskModel'][field.field]"
                          no-label
                          format="YYYY-MM-DD HH:mm"
                        />

                        <!-- <VueCtkDateTimePicker
                          locale="mn"
                          no-label
                          format="MM-YYYY"
                        /> -->
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 7">
                      <!-- :value="$data['taskModel'][field.field]"
                          @on-change="(value) => $data['taskModel'][field.field] = value.toLocaleString()+'-01-01T00:00:00'" -->
                      <FormItem
                        :prop="field.field"
                        :label="field.title"
                        :key="`yearpkr7_${i}`"
                      >
                        <DatePicker
                          v-model="$data['taskModel'][field.field]"
                          type="year"
                          placeholder="Select date"
                          style="width: 100%"
                          :format="'yyyy'"
                          :value-format="'yyyy-MM-dd HH:mm:ss'"
                        ></DatePicker>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 8">
                      <Divider :key="`dvdr${i}`">{{ field.title }}</Divider>
                    </template>
                    <template v-else-if="field.flag === 9">
                      <FormItem
                        :key="`psu2_${i}`"
                        v-show="taskModel.id <= 0"
                        label="Ажил хэрэг"
                        class="m-b-xs"
                      >
                        <project-dropdown
                          v-if="taskModelRdy"
                          :disabled="true"
                          :id="taskModel.projectId"
                          @on-proj-selected="projSelected"
                        ></project-dropdown>
                      </FormItem>
                      <FormItem
                        :key="`psu3_${i}`"
                        v-show="columns.length && taskModel.id <= 0"
                        label="Алхам"
                        class="m-b-xs"
                      >
                        <Select
                          ref="columns"
                          v-model="columnSelected"
                          filterable
                          clearable
                          @change="columnChange(columnSelected)"
                          class="wd-100p"
                        >
                          <Option
                            :value="c.id"
                            :label="c.title"
                            :key="c.id"
                            v-for="c in columns"
                          ></Option>
                        </Select>
                      </FormItem>
                      <FormItem
                        :key="`psu4_${i}`"
                        v-show="users.length && taskModel.id <= 0"
                        label="Хэрэглэгч"
                        class="m-b-xs"
                      >
                        <Select
                          v-model="userSelected"
                          multiple
                          filterable
                          clearable
                          @change="userChange"
                          class="wd-100p"
                        >
                          <OptionGroup
                            :key="di"
                            v-for="(d, di) in departs"
                            :label="
                              d.label +
                                ' - ' +
                                users.filter((u) => u.departId == d.id).length
                            "
                          >
                            <Option
                              :label="u.fullName"
                              :value="u.userId"
                              :key="u.userId"
                              v-for="u in users.filter(
                                (u) => u.departId == d.id
                              )"
                            >
                              <div class="d-flex">
                                <div class="avatar avatar-xs">
                                  <img :src="u.avator" />
                                </div>
                                <div class="tx-13 pd-l-5">
                                  {{ u.fullName }}
                                  <div class="tx-12 text-muted">
                                    {{ u.position }}
                                  </div>
                                </div>
                              </div>
                            </Option>
                          </OptionGroup>
                          <OptionGroup
                            label="Бусад"
                            v-if="
                              users.filter(
                                (u) => u.departId == 0 || u.departId == null
                              ).length > 0
                            "
                          >
                            <Option
                              :label="u.fullName"
                              :value="u.userId"
                              :key="u.userId"
                              v-for="u in users.filter(
                                (u) => u.departId == 0 || u.departId == null
                              )"
                            >
                              <div class="d-flex">
                                <div class="avatar avatar-xs">
                                  <img :src="u.avator" />
                                </div>
                                <div class="tx-13 pd-l-5">
                                  {{ u.fullName }}
                                  <div class="tx-12 text-muted">
                                    {{ u.position }}
                                  </div>
                                </div>
                              </div>
                            </Option>
                          </OptionGroup>
                        </Select>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                      <FormItem
                        :key="`psu5_${i}`"
                        v-show="users.length && taskModel.id <= 0"
                        label="Хугацаа"
                        class="m-b-xs"
                      >
                        <!-- <Input v-model="$data['taskModel']['columnDueDate']" placeholder="..." /> -->
                        <DatePicker
                          v-model="$data['taskModel']['columnDueDate']"
                          placeholder="Огноо сонгоно уу"
                          type="datetime"
                          style="width: 100%"
                          :format="'yyyy-MM-dd HH:mm:ss'"
                          :value-format="'yyyy-MM-dd HH:mm:ss'"
                        ></DatePicker>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 11">
                      <div :key="`lbl_${i}`">{{ field.title }}</div>
                    </template>
                    <template v-else-if="field.flag === 12">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <RadioGroup v-model="$data['taskModel'][field.field]">
                          <Radio :label="1">
                            <span>Тийм</span>
                          </Radio>
                          <Radio :label="0">
                            <span>Үгүй</span>
                          </Radio>
                        </RadioGroup>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 15">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <InputNumber
                          :disabled="taskModel.objectTypeId == 533"
                          v-model="$data['taskModel'][field.field]"
                        ></InputNumber>
                        <span
                          class="text-muted p-l-sm"
                          v-if="$data['taskModel'][field.field] > 999"
                          >{{
                            $data["taskModel"][field.field]
                              | formatMoney(0, ".", ",")
                          }}</span
                        >
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 18">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <!-- <div style="clear:both"></div> -->
                        <summernote
                          v-if="!$store.state.app.isMobile"
                          v-model="$data['taskModel'][field.field]"
                          :text="$data['taskModel'][field.field]"
                        ></summernote>
                        <Input
                          v-else-if="field.maxlength > 0"
                          v-model="$data['taskModel'][field.field]"
                          type="textarea"
                          :maxlength="field.maxlength"
                        />
                        <Input
                          v-else
                          v-model="$data['taskModel'][field.field]"
                          type="textarea"
                        />
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>

                    <template v-else-if="field.flag == 20">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <loctype-multiple-tag
                          v-model="$data['taskModel'][field.field]"
                          :ids.sync="$data['taskModel'][field.field]"
                          :lkey.sync="field.key"
                          :hideIcon="true"
                        ></loctype-multiple-tag>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>

                    <template v-else-if="field.flag === 22">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <!-- <InputNumber v-model="$data['taskModel'][field.field]"></InputNumber> -->
                        <Checkbox v-model="$data['taskModel'][field.field]" />
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 24">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <!-- {{  field.field }} -->
                        <task-finder
                          v-model="$data['taskModel'][field.field]"
                          :selectedId="$data['taskModel'][field.field]"
                          @on-task-selected="field.cstmFld2 = $event.task"
                          :objectTypeId.sync="[field.key][0]"
                          :fieldName="field.field"
                          :prmsProp="prms"
                          :key="`tsk_${i}`"
                          :parentTaskId="
                            prms.parentTask != null ? prms.parentTask.id : 0
                          "
                        ></task-finder>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 25">
                      <span :key="`lbl_${i}`" style="display: none">{{
                        ($data["taskModel"]["task"] = "гарчиггүй")
                      }}</span>
                    </template>
                    <template v-else-if="field.flag === 30">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <depart-cascader
                          :checkStrictly="true"
                          :id="$data['taskModel'][field.field]"
                          v-model="$data['taskModel'][field.field]"
                        />
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template
                      v-else-if="
                        field.flag === 31 &&
                          ($data['taskModel']['objectTypeId'] == 458
                            ? hasPerr(['crmlicenseacceptor'])
                            : true)
                      "
                    >
                      <div :key="`lbl_${i}`">
                        <FormItem
                          :rules="field.rule"
                          :prop="field.field"
                          :label="field.title"
                          :key="`lbl_${i}`"
                        >
                          <simple-uploader
                            v-model="$data['taskModel'][field.field]"
                            :propBoxId="0"
                            :propObjectId="'0'"
                            :propObjectTypeId="
                              $data['taskModel']['objectTypeId']
                            "
                            @on-success="fileUploaded($event, field)"
                          >
                            <div slot="trigger">
                              <div
                                v-if="$data['taskModel'][field.key] == ''"
                                class="btn-group wd-100p"
                              >
                                <div class="btn btn-outline-success">
                                  <feather
                                    type="upload"
                                    class="mg-r-5"
                                  ></feather>
                                  <span>Компьютероос хуулах</span>
                                </div>
                                <div
                                  v-if="simplUpldrHasDrive()"
                                  @click.stop="showFinder(field)"
                                  class="btn btn-outline-primary"
                                >
                                  <feather
                                    type="archive"
                                    class="mg-r-5"
                                  ></feather>
                                  <span>Динамик драйваас сонгох</span>
                                </div>
                              </div>
                              <div v-else class="btn-group wd-100p">
                                <div
                                  @click.stop="
                                    $emit(
                                      'on-attach',
                                      $data['taskModel'][field.field]
                                    )
                                  "
                                  class="btn btn-outline-success"
                                >
                                  <feather type="eye"></feather>Файл харах
                                </div>
                                <div
                                  class="btn btn-danger"
                                  @click.prevent.stop="
                                    $data['taskModel'][field.field] = null;
                                    $data['taskModel'][field.key] = '';
                                  "
                                >
                                  <feather type="x"></feather>Салгах
                                </div>
                              </div>
                            </div>
                          </simple-uploader>
                          <div class="text-muted tx-11 eddt-title-info">
                            {{ infoBuilder(field.info) }}
                          </div>
                          <div v-if="$store.state.app.activeGroup.id == 9298 
                          && field.field === 'defaultAttachmentId'
                          && taskModel.objectTypeId === 561
                          " class="d-flex justify-content-end">
                            <a @click="vfdfgt()" class="btn btn-xs btn-primary">Загвар татах</a>
                          </div>
                        </FormItem>
                      </div>
                    </template>
                    <template v-else-if="field.flag === 36">
                      <span :key="`lbl_${i}`" style="display: none">{{
                        ($data["taskModel"]["parentId"] = 0)
                      }}</span>
                    </template>
                    <template v-else-if="field.flag === 39"></template>
                    <template v-else-if="field.flag === 42">
                      <FormItem
                        :label="field.title"
                        class="m-b-xs"
                        :key="`lbl_${i}`"
                      >
                        <!-- Web component selector 355 -->
                        <Input
                          :maxlength="field.maxlength"
                          v-if="prms.parentId == 0"
                          v-model="$data['taskModel'][field.field]"
                        />
                        <Select
                          v-else
                          v-model="$data['taskModel'][field.field]"
                          filterable
                          clearable
                        >
                          <Option
                            :value="tw.st1"
                            v-for="(tw, twi) in webComponents"
                            :key="twi"
                            :label="tw.task"
                          >
                            {{ tw.task }}
                            <div
                              class="p-l-sm"
                              style="float: right; color: #ccc"
                            >
                              {{ tw.st2 }}
                            </div>
                          </Option>
                        </Select>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 49">
                      <!-- reserved server tald utga hadgalsan -->
                    </template>
                    <template v-else-if="field.flag === 50">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <div
                          v-if="
                            prms.parentTask != undefined &&
                              $data['taskModel'][field.field] == null
                          "
                        >
                          <span style="display: none">{{
                            ($data["taskModel"][field.field] =
                              prms.parentTask.id)
                          }}</span>
                        </div>
                        <task-finder
                          v-model="$data['taskModel'][field.field]"
                          :selectedId="$data['taskModel'][field.field]"
                          @on-task-selected="onTaskSelected(field, $event)"
                          :objectTypeId.sync="[field.key][0]"
                          :key="`tsk_${i}`"
                        ></task-finder>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 51">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <loctype-multiple-tag
                          v-model="$data['taskModel'][field.field]"
                          :ids.sync="$data['taskModel'][field.field]"
                          :lkey.sync="
                            field.key + '_' + $data['taskModel']['projectId']
                          "
                        ></loctype-multiple-tag>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 53">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        class="m-b-xs"
                      >
                        <Select
                          v-model="$data['taskModel'][field.field]"
                          filterable
                        >
                          <Option :value="0" :key="0" :label="'Цоожтой'"
                            >Цоожтой</Option
                          >
                          <Option :value="1" :key="1" :label="'Нээлттэй'"
                            >Нээлттэй</Option
                          >
                          <Option
                            :value="2"
                            :key="2"
                            :label="'Хүсэлт илгээх боломжтой (гишүүд)'"
                            >Хүсэлт илгээх боломжтой (гишүүд)</Option
                          >
                          <Option
                            :value="3"
                            :key="3"
                            :label="
                              'Хүсэлт илгээх боломжтой (бүртгүүлсэн хэрэглэгч)'
                            "
                            >Хүсэлт илгээх боломжтой (бүртгүүлсэн
                            хэрэглэгч)</Option
                          >
                          <Option
                            :value="9900"
                            :key="9900"
                            :label="'Сонгогдсон хавчуурга заавал хамрагдах'"
                            >Сонгогдсон хавчуурга заавал хамрагдах</Option
                          >
                        </Select>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 54">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        class="m-b-xs"
                      >
                        <Select
                          v-model="$data['taskModel'][field.field]"
                          filterable
                          clearable
                        >
                          <Option :key="0" :value="0" :label="'Тийм'"
                            >Тийм</Option
                          >
                          <Option :key="1" :value="1" :label="'Шаардлагагүй'"
                            >Шаардлагагүй</Option
                          >
                        </Select>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 55">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        class="m-b-xs"
                      >
                        <Select
                          v-model="$data['taskModel'][field.field]"
                          filterable
                        >
                          <Option
                            :key="0"
                            :value="0"
                            :label="'Зөвхөн шалгалтаар'"
                            >Зөвхөн шалгалтаар</Option
                          >
                          <Option
                            :key="1"
                            :value="1"
                            :label="'Нэмэлт оноо тооцно /Явц + Ирц + Шалгалт/'"
                            >Нэмэлт оноо тооцно /Явц + Ирц + Шалгалт/</Option
                          >
                        </Select>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 56">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        class="m-b-xs"
                      >
                        <Select
                          v-model="$data['taskModel'][field.field]"
                          filterable
                        >
                          <Option :key="0" :value="0" :label="'Үгүй'"
                            >Үгүй</Option
                          >
                          <Option :key="1" :value="1" :label="'Тийм'"
                            >Тийм</Option
                          >
                        </Select>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 57">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        class="m-b-xs"
                      >
                        <Select
                          v-model="$data['taskModel'][field.field]"
                          filterable
                        >
                          <Option
                            :key="1"
                            :value="1"
                            :label="
                              'Зөвхөн хичээлд хавсаргасан хүмүүс үзэх эрхтэй'
                            "
                            >Зөвхөн хичээлд хавсаргасан хүмүүс үзэх
                            эрхтэй</Option
                          >
                          <Option
                            :key="0"
                            :value="0"
                            :label="
                              'Сургалттад хавсаргагдсан бүх хүмүүс үзэх эрхтэй'
                            "
                            >Сургалтад хавсаргагдсан бүх хүмүүс үзэх
                            эрхтэй</Option
                          >
                        </Select>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 59">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <div
                          v-if="
                            prms.parentTask != undefined &&
                              $data['taskModel'][field.field] == null
                          "
                        >
                          <span style="display: none">{{
                            ($data["taskModel"][field.field] =
                              prms.parentTask.id)
                          }}</span>
                        </div>
                        <task-finder
                          v-model="$data['taskModel'][field.field]"
                          :selectedId="$data['taskModel'][field.field]"
                          @on-task-selected="field.cstmFld2 = $event.task"
                          :objectTypeId.sync="[field.key][0]"
                          :key="`tsk_${i}`"
                        ></task-finder>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 60">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <div
                          v-if="
                            prms.parentTask != undefined &&
                              $data['taskModel'][field.field] == null
                          "
                        >
                          <span style="display: none">{{
                            ($data["taskModel"][field.field] =
                              prms.parentTask.id)
                          }}</span>
                        </div>
                        <loc-type-cascader-assign-task
                          :id="$data['taskModel'][field.field]"
                          :txt="$data['taskModel'][field.key.split(':')[1]]"
                          v-model="$data['taskModel'][field.field]"
                          :getParentType="true"
                          :locTypekey="field.key"
                          :otherTxt="field.info"
                          @loctype-selected="locTypeAssignTask"
                        />
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 63">
                      <!-- //{{orgSelectedId =  -->
                      <!-- //if(isNaN(this.orgSelectedId))
            //this.orgSelectedId = null;
                      //}}-->
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <!-- <div :key="`lbl_${i}`" v-if="!hasPerr(['crmlicenseacceptor'])">
                        {{$data['taskModel'][field.field] = parseInt($store.state.user.defaultTasks['organizationTaskId'], 10)}}
                        </div>-->
                        <crm-user-default-company-selecter
                          :selectedId="$data['taskModel'][field.field]"
                          v-model="$data['taskModel'][field.field]"
                        ></crm-user-default-company-selecter>

                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>

                    <template v-else-if="field.flag === 68">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <hrm-tag-assign
                          :editKey="field.key"
                          :fld="$data['taskModel'][field.field]"
                          v-model="$data['taskModel'][field.field]"
                        ></hrm-tag-assign>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 69">
                      <!-- {{field}} -->
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <loc-type-cascader-with-field
                          :ref="`ltCasWF_${field.field}`"
                          @on-change="locTypeFieldOnChange($event, field.field)"
                          @on-data-fired="locTypeCascaderOnDataFired(field)"
                          :id="$data['taskModel'][field.field]"
                          v-model="$data['taskModel'][field.field]"
                          :getParentType="true"
                          :locTypekey="field.key"
                          :key="locTypeId4IncrementKey"
                          :disabled="disableLocTypeCascaderWithField"
                        />
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                      <template v-if="locTypeFields.draw">
                        <Divider
                          v-if="locTypeFields.fields.length > 0"
                          :key="`dvd_${i}`"
                          >Хүчин зүйл</Divider
                        >
                        <div v-else :key="`dvd1_${i}`">
                          <FormItem label="Хүчин зүйл" :key="`lbl_${i}`">
                            <div
                              role="alert"
                              class="
                                alert alert-info
                                fade
                                show
                                pd-0 pd-l-15
                                mg-b-0
                              "
                            >
                              <strong>Хүчин зүйл тохируулаагүй байна.</strong>
                            </div>
                          </FormItem>
                        </div>
                        <!-- <Form
                    :model="locTypeFields.model"
                    ref="formValidate"
                    label-width="30%"
                    style="background: rgba(0,0,0,0.05)"
                    class="p-sm"
                        >-->
                        <!-- {{locTypeFields.fields}} -->
                        <div
                          v-for="(f, i) in locTypeFields.fields"
                          :key="i"
                          class="ltfs bg-gray-100 pd-l-10"
                        >
                          <!-- f.type=> {{f.property.type}} -->

                          <!-- {{f.property.type}} -->

                          <template
                            v-if="f.property.type == 1 || f.property.type == 2"
                          >
                            <FormItem
                              :class="{
                                'is-error': f.property.isValid == false,
                                'is-required': f.property.rule.required,
                              }"
                              :label="f.property.title"
                            >
                              <Select
                                v-if="taskModel.id == 0"
                                @change="
                                  locTypeFieldOnSet(f.property.type, $event, f)
                                "
                                :multiple="f.property.type == 2"
                                collapse-tags
                                v-model="f.property.value"
                                style="width: 100%"
                                size="medium"
                              >
                                <Option
                                  :key="vi"
                                  v-for="(v, vi) in f.property.values"
                                  :value="v.id"
                                  :label="v.value"
                                  >{{ v.value }}</Option
                                >
                              </Select>
                              <Select
                                v-else
                                @change="
                                  locTypeFieldOnSet(f.property.type, $event, f)
                                "
                                v-model="f.property.value"
                                :multiple="f.property.type == 2"
                                collapse-tags
                              >
                                <Option
                                  :key="vi"
                                  v-for="(v, vi) in f.property.values"
                                  :value="v.id"
                                  :label="v.value"
                                  >{{ v.value }} {{ v.id }}</Option
                                >
                              </Select>

                              <div
                                class="el-form-item__error"
                                v-show="f.property.isValid == false"
                              >
                                {{ f.property.rule.message }}
                              </div>
                            </FormItem>
                          </template>
                          <template v-else-if="f.property.type == 3">
                            <FormItem
                              :label="f.property.title"
                              :key="`ff_` + f.id"
                              :class="{
                                'is-error': f.property.isValid == false,
                                'is-required': f.property.rule.required,
                              }"
                            >
                              <Input
                                type="textarea"
                                :rows="3"
                                v-if="taskModel.id == 0 || ltFieldOnReset"
                                @change="
                                  locTypeFieldOnSet(f.property.type, $event, f)
                                "
                                :maxlength="450"
                                style="f.property.isValid"
                                v-model="f.property.value"
                              />
                              <!-- v-model="f.property.selectedValues[0]" -->
                              <Input
                                type="textarea"
                                :rows="3"
                                v-else
                                @change="
                                  locTypeFieldOnSet(f.property.type, $event, f)
                                "
                                v-model="f.property.selectedValues[0]"
                                :maxlength="450"
                              />
                              <!-- {{f.property}} -->
                              <div
                                class="el-form-item__error"
                                v-show="f.property.isValid == false"
                              >
                                {{ f.property.rule.message }}
                              </div>
                            </FormItem>
                          </template>
                          <template v-else-if="f.property.type == 4">
                            <!-- {{f.property.selectedValues}}
                            {{f.property.value}} -->
                            <FormItem
                              :class="{
                                'is-error': f.property.isValid == false,
                                'is-required': f.property.rule.required,
                              }"
                              :label="
                                f.property.title +
                                  (f.property.measure != ''
                                    ? ' (' + f.property.measure + ')'
                                    : '')
                              "
                            >
                              <!-- {{f.property.value}} {{f.property.selectedValues[0]}} -->
                              <!-- <Button @click="locTypeFieldOnSet(f.property.type, 5, f)">set 5</Button> -->
                              <InputNumber
                                v-if="taskModel.id == 0"
                                @change="
                                  locTypeFieldOnSet(f.property.type, $event, f)
                                "
                                v-model="f.property.value"
                              />
                              <InputNumber
                                v-else
                                @change="
                                  locTypeFieldOnSet(f.property.type, $event, f)
                                "
                                v-model="f.property.selectedValues[0]"
                              />
                              <span
                                class="text-muted p-l-sm"
                                v-if="f.property.selectedValues[0] > 999"
                                >{{
                                  f.property.selectedValues[0]
                                    | formatMoney(0, ".", ",")
                                }}</span
                              >
                              <div
                                class="el-form-item__error"
                                v-show="f.property.isValid == false"
                              >
                                {{ f.property.rule.message }}
                              </div>
                            </FormItem>
                          </template>
                          <template v-else-if="f.property.type == 5">
                            <!-- {{f.property}} -->
                            <!-- {{f.property.selectedValues[0]}}
                            {{taskModel.id==0 || ltFieldOnReset}} -->
                            <FormItem
                              :class="{
                                'is-error': f.property.isValid == false,
                                'is-required': f.property.rule.required,
                              }"
                              :label="f.property.title"
                            >
                              <DatePicker
                                v-if="taskModel.id == 0"
                                @change="
                                  locTypeFieldOnSet(f.property.type, $event, f)
                                "
                                v-model="f.property.value"
                                placeholder="Огноо сонгоно уу"
                                type="date"
                                :format="'yyyy-MM-dd'"
                                :value-format="'yyyy-MM-dd'"
                                style="width: 100%"
                              ></DatePicker>
                              <DatePicker
                                v-else
                                @change="
                                  locTypeFieldOnSet(f.property.type, $event, f)
                                "
                                v-model="f.property.selectedValues[0]"
                                placeholder="Огноо сонгоно уу"
                                type="date"
                                :format="'yyyy-MM-dd'"
                                :value-format="'yyyy-MM-dd'"
                                style="width: 100%"
                              ></DatePicker>
                              <div
                                class="el-form-item__error"
                                v-show="f.property.isValid == false"
                              >
                                {{ f.property.rule.message }}
                              </div>
                            </FormItem>
                          </template>

                          <template v-else-if="f.property.type == 6">
                            <FormItem
                              width="auto"
                              :class="{
                                'is-error': f.property.isValid == false,
                                'is-required': f.property.rule.required,
                              }"
                              :label="
                                f.property.title +
                                  (f.property.measure != ''
                                    ? ' (' + f.property.measure + ')'
                                    : '')
                              "
                            >
                              <simple-uploader
                                :propBoxId="0"
                                :propObjectId="'0'"
                                :propObjectTypeId="6"
                                @on-success="fileUploadedProperty($event, f)"
                              >
                                <div slot="trigger">
                                  <div
                                    v-if="
                                      f.property.value == null ||
                                        f.property.value == undefined ||
                                        f.property.value == ''
                                    "
                                    class="btn-group wd-100p"
                                  >
                                    <div class="btn btn-outline-success">
                                      <feather
                                        type="upload"
                                        class="mg-r-5"
                                      ></feather>
                                      <span>Компьютероос хуулах</span>
                                    </div>
                                    <div
                                      @click.stop="showFinder(f, 2)"
                                      class="btn btn-outline-primary"
                                    >
                                      <feather
                                        type="archive"
                                        class="mg-r-5"
                                      ></feather>
                                      <span>Динамик драйваас сонгох</span>
                                    </div>
                                  </div>
                                  <div v-else class="btn-group wd-100p">
                                    <div
                                      @click.stop="
                                        $emit('on-attach', f.property.value)
                                      "
                                      class="btn btn-outline-success"
                                    >
                                      <feather type="eye"></feather>Файл харах
                                    </div>
                                    <div
                                      class="btn btn-danger"
                                      @click.prevent.stop="
                                        locTypeFieldOnSet(
                                          f.property.type,
                                          null,
                                          f
                                        )
                                      "
                                    >
                                      <feather type="x"></feather>Салгах
                                    </div>
                                  </div>
                                </div>
                              </simple-uploader>

                              <div
                                class="el-form-item__error"
                                v-show="f.property.isValid == false"
                              >
                                {{ f.property.rule.message }}
                              </div>
                            </FormItem>
                          </template>
                          <template v-else-if="f.property.type == 7">
                            <!-- <Divider :key="`dvd_${i}`" >{{ f.property.title }}</Divider> -->
                            <div class="bd-y bd-1 pd-10 bg-gray-200">
                              {{ f.property.title }}
                            </div>
                          </template>

                          <div
                            v-if="f.property.info != ''"
                            class="alert alert-warning alert-dismissible fade show"
                            role="alert"
                          >
                            <strong>Санамж</strong> {{ f.property.info }}
                          </div>
                        </div>
                        <!-- </Form> -->
                      </template>
                    </template>
                    <template v-else-if="field.flag === 70">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                      <!-- {{ field }} -->
                        <simple-uploader
                          v-model="$data['taskModel'][field.field]"
                          :propBoxId="0"
                          :propObjectId="'0'"
                          :propObjectTypeId="$data['taskModel']['objectTypeId']"
                          @on-success="fileUploaded($event, field)"
                        >
                          <div slot="trigger">
                            <div
                              v-if="$data['taskModel'][field.key] == ''"
                              class="btn-group wd-100p"
                            >
                              <div class="btn btn-outline-success">
                                <feather type="upload" class="mg-r-5"></feather>
                                <span>Компьютероос хуулах</span>
                              </div>
                              <div
                                @click.stop="showFinder(field)"
                                class="btn btn-outline-primary"
                              >
                                <feather
                                  type="archive"
                                  class="mg-r-5"
                                ></feather>
                                <span>Динамик драйваас сонгох</span>
                              </div>
                            </div>
                            <div v-else class="btn-group wd-100p">
                              <div
                                @click.stop="
                                  $emit(
                                    'on-attach',
                                    $data['taskModel'][field.field]
                                  )
                                "
                                class="btn btn-outline-success"
                              >
                                <feather type="eye"></feather>Файл харах
                              </div>
                              <div
                                class="btn btn-danger"
                                @click.prevent.stop="
                                  $data['taskModel'][field.field] = null;
                                  $data['taskModel'][field.key] = '';
                                "
                              >
                                <feather type="x"></feather>Салгах
                              </div>
                            </div>
                          </div>
                        </simple-uploader>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 74">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <template v-if="hasPerr(['assetevaluation'])">
                          <span style="display: none">{{
                            ($data["taskModel"][field.field] = true)
                          }}</span>
                          <Checkbox
                            :disabled="true"
                            v-model="$data['taskModel'][field.field]"
                          ></Checkbox>
                        </template>
                        <Checkbox
                          v-else
                          v-model="$data['taskModel'][field.field]"
                        ></Checkbox>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 75">
                      <!-- :rules="field.rule" -->
                      <FormItem
                        :key="`lbl_${i}`"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <RadioGroup
                          v-model="createdUser.mode"
                          @on-change="createdUserChanged"
                        >
                          <Radio label="1">
                            <span v-if="$store.state.app.activeGroup.id == 9298"
                              >Иргэний бүртгэлийн дугаар</span
                            >
                            <span v-else>Нэвтрэх нэр (Бүртгэл №)</span>
                          </Radio>
                          <Radio
                            label="2"
                            v-if="$store.state.app.activeGroup.id != 9298"
                          >
                            <span>Регистр №</span>
                          </Radio>
                          <Radio label="3">
                            <span>Нэр</span>
                          </Radio>
                        </RadioGroup>
                        <Input v-model="createdUser.value">
                          <!-- enter-button="Хайх" -->
                          <!-- search -->
                          <a
                            @click="createdUserRemove"
                            v-if="
                              createdUser.field != null ||
                                $data['taskModel']['secondUserId'] != null
                            "
                            class="btn btn-ligh"
                            slot="prepend"
                          >
                            <feather type="x" class="text-danger"></feather>
                          </a>
                          <a
                            @click="createdUserFind(field)"
                            slot="append"
                            type=""
                            class="btn"
                          >
                            Хайх
                          </a>
                        </Input>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 76">
                      <FormItem
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                      >
                        <DatePicker
                          v-model="$data['taskModel'][field.field]"
                          placeholder="Огноо сонгоно уу"
                          type="date"
                          :format="'yyyy-MM-dd'"
                          :value-format="'yyyy-MM-dd'"
                          style="width: 100%"
                        ></DatePicker>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 81">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <DatePicker
                          v-model="$data['taskModel'][field.field]"
                          type="month"
                          placeholder="Select date"
                          style="width: 100%"
                          :format="'yyyy-MM'"
                          :value-format="'yyyy-MM'"
                        ></DatePicker>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 82">
                      <FormItem
                        :key="`cscrdassigntsk_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <loc-type-cascader-assign-task-other
                          :id="$data['taskModel'][field.field]"
                          :txt="$data['taskModel'][field.key.split(':')[1]]"
                          v-model="$data['taskModel'][field.field]"
                          :getParentType="true"
                          :locTypekey="field.key"
                          :otherTxt="field.info"
                          @loctype-selected="locTypeAssignTaskOther"
                        />
                        <!--  -->
                      </FormItem>
                    </template>

                    <template v-else-if="field.flag === 83">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <vet-client-user-org-selecter
                          :selectedId="$data['taskModel'][field.field]"
                          v-model="$data['taskModel'][field.field]"
                        ></vet-client-user-org-selecter>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 85">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <task-finder
                          v-model="$data['taskModel'][field.field]"
                          :selectedId="$data['taskModel'][field.field]"
                          @on-task-selected="field.cstmFld2 = $event.task"
                          :objectTypeId.sync="[field.key][0]"
                          :key="`tsk_${i}`"
                        ></task-finder>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 87">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <task-finder
                          v-model="$data['taskModel'][field.field]"
                          :selectedId="$data['taskModel'][field.field]"
                          @on-task-selected="
                            field.cstmFld2 = $event.task;
                            $data['taskModel']['task'] = $event.task;
                          "
                          :objectTypeId.sync="[field.key][0]"
                          :key="`tsk_${i}`"
                        ></task-finder>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 88">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                        style="position: relatove"
                      >
                        <div
                          v-if="
                            prms.parentTask != undefined &&
                              $data['taskModel'][field.field] == null
                          "
                        >
                          <span style="display: none">{{
                            ($data["taskModel"][field.field] =
                              prms.parentTask.organizationTaskId)
                          }}</span>
                        </div>
                        <task-finder
                          v-model="$data['taskModel'][field.field]"
                          :selectedId="$data['taskModel'][field.field]"
                          @on-task-selected="field.cstmFld2 = $event.task"
                          :objectTypeId.sync="[field.key][0]"
                          :key="`tsk_${i}`"
                        ></task-finder>
                        <!-- <div
                                  class="btn btn-danger"
                                  @click.prevent.stop="$data['taskModel'][field.field]=null; $data['taskModel'][field.key]=''"
                                >
                                  
                        </div>-->

                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 90">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <access-finder
                          :selected="$data['taskModel'][field.field]"
                          v-model="$data['taskModel'][field.field]"
                        />
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 91">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        {{ $data["taskModel"]["lat"] }}
                        <GmapMap
                          :center="{
                            lat:
                              $data['taskModel']['lat'] != null
                                ? parseFloat($data['taskModel']['lat'])
                                : 47.9138932,
                            lng:
                              $data['taskModel']['lng'] != null
                                ? parseFloat($data['taskModel']['lng'])
                                : 106.8986408,
                          }"
                          :zoom="13"
                          map-type-id="roadmap"
                          style="width: 100%; height: 300px"
                          @click="createMapMarker"
                        >
                          <GmapMarker
                            v-for="(m, i) in googleMapMaker"
                            :key="i"
                            :position="m.position"
                          />
                        </GmapMap>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 92">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        class="m-b-xs"
                      >
                        <Select
                          v-model="$data['taskModel'][field.field]"
                          filterable
                          clearable
                        >
                          <Option
                            :key="0"
                            :value="0"
                            :label="'Эхлэх дуусах хугацаагаар'"
                            >Эхлэх дуусах хугацаагаар</Option
                          >
                          <Option
                            :key="9"
                            :value="9"
                            :label="'Эхэлсэн өдрөөс хичээллөх өдрийн тоогоор'"
                            >Эхэлсэн өдрөөс хичээллөх өдрийн тоогоор</Option
                          >
                        </Select>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 93">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        class="m-b-xs"
                      >
                        <span class="tx-info" v-show="taskModel.i1 == 1"
                          >баталгаажсан</span
                        >
                        <span class="tx-warning" v-show="taskModel.i1 == 0"
                          >шинэ</span
                        >
                        <span v-show="taskModel.i1 == 2" class="tx-success"
                          >буцаан авсан</span
                        >
                        <span class="tx-danger" v-show="taskModel.i1 == -1"
                          >цуцалсан</span
                        >
                        захиалга
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 94">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <loctype-multiple-tag
                          v-model="$data['taskModel'][field.field]"
                          :ids.sync="$data['taskModel'][field.field]"
                          :lkey="getProjId(field.key)"
                        ></loctype-multiple-tag>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 95">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <div
                          v-if="
                            prms.parentTask != undefined &&
                              $data['taskModel'][field.field] == null
                          "
                        >
                          <span style="display: none">{{
                            ($data["taskModel"][field.field] =
                              prms.parentTask.secondOrganizationTaskId)
                          }}</span>
                        </div>
                        <task-finder
                          v-model="$data['taskModel'][field.field]"
                          :selectedId="$data['taskModel'][field.field]"
                          @on-task-selected="field.cstmFld2 = $event.task"
                          :objectTypeId.sync="[field.key][0]"
                          :key="`tsk_${i}`"
                        ></task-finder>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 96">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <div
                          v-if="
                            prms.parentTask != undefined &&
                              $data['taskModel'][field.field] == null
                          "
                        >
                          <span style="display: none">{{
                            ($data["taskModel"][field.field] =
                              prms.parentTask.thirdOrganizationTaskId)
                          }}</span>
                        </div>
                        <task-finder
                          v-model="$data['taskModel'][field.field]"
                          :selectedId="$data['taskModel'][field.field]"
                          @on-task-selected="field.cstmFld2 = $event.task"
                          :objectTypeId.sync="[field.key][0]"
                          :key="`tsk_${i}`"
                        ></task-finder>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 97">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <div
                          v-if="
                            prms.parentTask != undefined &&
                              $data['taskModel'][field.field] == null
                          "
                        >
                          <span style="display: none">{{
                            ($data["taskModel"][field.field] =
                              prms.parentTask.fourthOrganizationTaskId)
                          }}</span>
                        </div>
                        <task-finder
                          v-model="$data['taskModel'][field.field]"
                          :selectedId="$data['taskModel'][field.field]"
                          @on-task-selected="field.cstmFld2 = $event.task"
                          :objectTypeId.sync="[field.key][0]"
                          :key="`tsk_${i}`"
                        ></task-finder>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag == 98">
                      <!-- {{$data['taskModel'][field.field] != null? false :true}}
                      {{$data['taskModel'][field.field]}}
                      {{prms.parentTask}}
                      {{taskModel.parentTask}} -->
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <!-- :disabled="($data['taskModel'][field.field] != null && taskModel.id!=0) ? true : false" -->
                        <!-- :parentFilterable="$data['taskModel'][field.field] != null? false :true" -->
                        <!-- :parentId="$data['taskModel'][field.field] != null? 0 : ( prms.parentTask!=undefined && prms.parentTask!=null ? prms.parentTask.locTypeId : 0)" -->
                        <!-- :checkStrictly="$data['taskModel'][field.field] != null ? true: false" -->

                        <loc-type-cascader
                          :id.sync="$data['taskModel'][field.field]"
                          v-model="$data['taskModel'][field.field]"
                          :getParentType="true"
                          :anyLevel="true"
                          :checkStrictly="false"
                          :parentFilterable="true"
                          :parentId="
                            taskModel.id == 0
                              ? prms.parentTask != undefined &&
                                prms.parentTask != null
                                ? prms.parentTask.locTypeId
                                : 0
                              : taskModel.parentTask != null
                              ? taskModel.parentTask.locTypeId
                              : 0
                          "
                          :locTypekey.sync="field.key"
                          @loctype-selected_withdata="
                            taskModel.taskEn =
                              (prms.parentTask != undefined &&
                              prms.parentTask != null &&
                              prms.parentTask.taskEn != undefined
                                ? prms.parentTask.taskEn
                                : '') + $event.data.code;
                            taskModel.id == 0
                              ? (taskModel.task = $event.data.label)
                              : '';
                          "
                        />
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 100">
                      <FormItem
                        v-if="taskModel.id == 0"
                        :rules="field.rule"
                        :label="field.title"
                        :prop="field.field"
                        :key="`lbl_${i}`"
                      >
                        <Input
                          v-if="field.maxlength > 0"
                          :placeholder="field.info"
                          v-model="$data['taskModel'][field.field]"
                          :maxlength="field.maxlength"
                        />
                        <Input
                          v-else
                          :placeholder="field.info"
                          v-model="$data['taskModel'][field.field]"
                        />
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 101">
                      <FormItem
                        :label="field.title"
                        :prop="field.field"
                        :key="`lbl_${i}`"
                      >
                        <Select
                          v-model="$data['taskModel'][field.field]"
                          filterable
                          clearable
                          class="wd-100p"
                        >
                          <Option :value="0" label="Цахим"></Option>
                          <Option :value="1" label="Биет"></Option>
                          <!-- <Option :value="2" label="Цаасан & Цахим"></Option> -->
                          <!-- tsesend gargasan uchir davhart hailt hiih bolomjgui bolood hasav -->
                        </Select>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 102">
                      <FormItem
                        :label="field.title"
                        :prop="field.field"
                        :key="`lbl_${i}`"
                      >
                        <Select
                          v-model="$data['taskModel'][field.field]"
                          filterable
                          clearable
                          class="wd-100p"
                        >
                          <!-- <Option
                            :value="0"
                            label="Вэб апп-р нэээгдэх"
                          ></Option> -->
                          <Option
                            :value="1"
                            label="Десктоп апп-р нэээгдэх"
                          ></Option>
                          <!-- <Option
                            :value="2"
                            label="Багш вэб апп-р, Сурагч десктоп апп-р нэээгдэх"
                          ></Option> -->
                        </Select>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 103">
                      <FormItem
                        :label="field.title"
                        :prop="field.field"
                        :key="`lbl_${i}`"
                      >
                        {{ $data["taskModel"][field.field] }}
                        <div style="overflow-x: auto">
                          <template v-if="taskModel.objectTypeId == 508">
                            <spec-asset-chooser
                              @on-asset-changed="assetChanged"
                              :locationId="
                                taskModel.id == 0
                                  ? prms.parentTask != null
                                    ? prms.parentTask.organizationTaskId
                                    : $data['taskModel']['organizationTaskId']
                                  : $data['taskModel']['organizationTaskId']
                              "
                              :assetId="
                                taskModel.id == 0
                                  ? prms.parentTask != null
                                    ? prms.parentTask.secondOrganizationTaskId
                                    : $data['taskModel'][
                                        'secondOrganizationTaskId'
                                      ]
                                  : $data['taskModel'][
                                      'secondOrganizationTaskId'
                                    ]
                              "
                              :mode="2"
                            ></spec-asset-chooser>
                          </template>
                          <template v-else>
                            <spec-asset-chooser
                              @on-asset-changed="assetChanged"
                              :locationId="
                                $data['taskModel']['organizationTaskId']
                              "
                              :assetId="
                                $data['taskModel']['secondOrganizationTaskId']
                              "
                              :mode="1"
                            ></spec-asset-chooser>
                          </template>
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 104">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <div
                          v-if="
                            prms.parentTask != undefined &&
                              $data['taskModel'][field.field] == null
                          "
                        >
                          <span style="display: none">{{
                            ($data["taskModel"][field.field] =
                              prms.parentTask.fifthOrganizationTaskId)
                          }}</span>
                        </div>
                        <task-finder
                          v-model="$data['taskModel'][field.field]"
                          :selectedId="$data['taskModel'][field.field]"
                          @on-task-selected="field.cstmFld2 = $event.task"
                          :objectTypeId.sync="[field.key][0]"
                          :key="`tsk_${i}`"
                        ></task-finder>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag == 105">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <loc-type-radio
                          @valueChanged="radioValueChanged(field.field, $event)"
                          :id.sync="$data['taskModel'][field.field]"
                          v-model="$data['taskModel'][field.field]"
                          :getParentType="true"
                          :locTypekey.sync="field.key"
                          :disabled="
                            taskModel.objectTypeId == 411 && taskModel.id != 0
                          "
                        />
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag == 106">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <spec-asset-list-chooser
                          v-model="$data['taskModel'][field.field]"
                          :typeId="field.key"
                          :selectedValue="$data['taskModel'][field.field]"
                        ></spec-asset-list-chooser>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag == 107">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <!-- {{$route.params}} -->
                        {{
                          ($data.taskModel.task =
                            $store.state.user.userInfo.fullName)
                        }}
                        <span style="display:none">
                          {{
                            ($data.taskModel.i1 = new Date(
                              $data.taskModel.createdDate
                            ).getFullYear())
                          }}
                          {{
                            ($data.taskModel.locTypeId = parseInt(
                              $route.params.locTypeId,
                              10
                            ))
                          }}
                        </span>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 108">
                      <FormItem
                        v-if="prms.boxId != undefined && prms.boxId > 0"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <div
                          v-if="
                            prms.parentTask != undefined &&
                              $data['taskModel'][field.field] == null
                          "
                        >
                          <span style="display: none">{{
                            ($data["taskModel"][field.field] =
                              prms.parentTask.id)
                          }}</span>
                        </div>
                        <task-finder
                          v-model="$data['taskModel'][field.field]"
                          :selectedId="$data['taskModel'][field.field]"
                          @on-task-selected="field.cstmFld2 = $event.task"
                          :objectTypeId.sync="[field.key][0]"
                          :key="`tsk_${i}`"
                        ></task-finder>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag == 109">
                      <div
                        v-if="prms.boxId != undefined && prms.boxId > 0"
                      ></div>
                      <FormItem
                        v-else
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <!-- || taskModel.objectTypeId == 533 -->
                        <loc-type-cascader
                          :id.sync="$data['taskModel'][field.field]"
                          v-model="$data['taskModel'][field.field]"
                          :getParentType="true"
                          :locTypekey.sync="field.key"
                          :disabled="
                            (taskModel.objectTypeId == 411 &&
                              taskModel.id != 0) ||
                              taskModel.objectTypeId == 533
                          "
                        />
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 110">
                      <div
                        v-if="prms.boxId != undefined && prms.boxId > 0"
                      ></div>
                      <FormItem
                        v-else
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <task-finder
                          v-model="$data['taskModel'][field.field]"
                          :selectedId="$data['taskModel'][field.field]"
                          @on-task-selected="field.cstmFld2 = $event.task"
                          :objectTypeId.sync="[field.key][0]"
                          :key="`tsk_${i}`"
                        ></task-finder>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 111">
                      <div
                        v-if="prms.boxId != undefined && prms.boxId > 0"
                      ></div>
                      <Divider v-else :key="`dvdr${i}`">{{
                        field.title
                      }}</Divider>
                    </template>
                    <template v-else-if="field.flag === 112">
                      <div
                        v-if="prms.boxId != undefined && prms.boxId > 0"
                      ></div>
                      <FormItem
                        v-else
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                      >
                        <VueCtkDateTimePicker
                          locale="mn"
                          v-model="$data['taskModel'][field.field]"
                          no-label
                          format="YYYY-MM-DD HH:mm"
                        />
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 113">
                      <div
                        v-if="prms.boxId != undefined && prms.boxId > 0"
                      ></div>
                      <FormItem
                        v-else
                        :rules="field.rule"
                        :label="field.title"
                        :prop="field.field"
                        :key="`lbl_${i}`"
                      >
                        <Input
                          v-if="field.maxlength > 0"
                          :placeholder="field.info"
                          v-model="$data['taskModel'][field.field]"
                          :maxlength="field.maxlength"
                        />
                        <Input
                          v-else
                          :placeholder="field.info"
                          v-model="$data['taskModel'][field.field]"
                        />
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 114">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <div class="d-flex">
                          <depart-cascader2
                            :pid="parseInt(field.key)"
                            :checkStrictly="false"
                            :id="$data['taskModel'][field.field]"
                            :id2="$data['taskModel']['departId2']"
                            v-model="$data['taskModel'][field.field]"
                            @on-change-2="
                              departCascader2Changed(field.key, $event)
                            "
                          />
                        </div>
                        <!-- {{ $data['taskModel'][field.field] }}
                          {{ $data['taskModel']['departId2'] }} -->
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 115">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <div class="d-flex" style="overflow: auto">
                          <loc-type-panel
                            v-model="$data['taskModel'][field.field]"
                            :ids.sync="$data['taskModel'][field.field]"
                            :lkey.sync="field.key"
                            :titl="field.title"
                            @on-selected="locTypePanelOnChange"
                          ></loc-type-panel>
                          <!-- {{$data['taskModel'][field.field]}} -->
                        </div>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>

                    <template v-else-if="field.flag === 116">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <task-finder-simple
                          v-model="$data['taskModel'][field.field]"
                          :selectedId="$data['taskModel'][field.field]"
                          @on-task-selected="
                            onTaskSelectedSimple(field, $event)
                          "
                          :objectTypeId.sync="[field.key][0]"
                          :fieldName="field.field"
                          :fld="field"
                          :prmsProp="prms"
                          :key="`tsk_${i}`"
                        ></task-finder-simple>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag == 37701">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <loc-type-journal
                          ref="rf_37701"
                          :prms="prms"
                          :id.sync="$data['taskModel'][field.field]"
                          v-model="$data['taskModel'][field.field]"
                          @on-journal-selcd="onJournalSelcd"
                          :getParentType="true"
                          :checkStrictly="true"
                          :locTypekey.sync="field.key"
                          :disabled="
                            (taskModel.objectTypeId == 411 &&
                              taskModel.id != 0) ||
                              taskModel.objectTypeId == 533
                          "
                        />
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>

                    <template v-else-if="field.flag == 88888">
                      <div
                        :key="`aaahidd${i}`"
                        role="button"
                        class="pd-10 rounded mg-b-20"
                        @click="hiddenFields = !hiddenFields"
                        style="background-color: rgb(255, 243, 223)"
                      >
                        <div class="d-flex align-items-center">
                          <div class="bg-warning pd-5 rounded">
                            <feather type="sliders"></feather>
                          </div>
                          <div
                            class="
                              mg-l-auto
                              tx-uppercase
                              tx-11
                              tx-spacing-1
                              tx-color-02
                              tx-semibold
                            "
                          >
                            нэмэлт мэдээлэл оруулах
                          </div>
                          <div class="mg-l-auto">
                            <feather
                              v-if="hiddenFields"
                              type="chevron-up"
                            ></feather>
                            <feather v-else type="chevron-down"></feather>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else-if="field.flag === 118">
                      <div :key="`us_im_msg${i}`">
                        <div class="row">
                          <div
                            v-for="(grpd,
                            i) in importUserFromFileInfoData.groupedByTitle"
                            :key="`td${i}`"
                            class="col-sm-6 col-xs-6 pointer"
                          >
                            <div
                              :class="
                                `col-sm-12 pointer bg-${
                                  grpd.systemMsg.systemTitle == 'Амжилттай'
                                    ? 'success'
                                    : 'danger'
                                }`
                              "
                            >
                              <h6
                                class="tx-uppercase tx-11  tx-white tx-spacing-1 tx-color-02 tx-semibold mg-b-10"
                              >
                                {{ grpd.systemMsg.systemTitle }}
                              </h6>
                              <h3
                                :class="
                                  `tx-normal tx-white tx-rubik tx-spacing--2 mg-b-5 ${grpd.systemMsg.systemClass}`
                                "
                              >
                                {{ grpd.count }}
                              </h3>

                              <p class="mg-b-0 tx-12 tx-color-03 tx-white">
                                {{
                                  grpd.systemMsg.systemTitle == "Амжилттай"
                                    ? "Сургалтад элсүүлэх хэрэглэгчийн тоо"
                                    : "Шинээр бүртгэл үүсгэх боломжгүй хэрэглэгчийн тоо"
                                }}
                              </p>
                            </div>
                            <div class="row">
                              <div
                                v-for="(item,
                                i) in importUserFromFileInfoData.grouped.filter(
                                  (x) =>
                                    x.systemMsg.systemTitle ==
                                    grpd.systemMsg.systemTitle
                                )"
                                :key="`d${i}`"
                                class="col-sm-3 pointer"
                                role="button"
                                @click="setFlag(item.systemMsg.systemFlag)"
                              >
                                <h3
                                  :class="
                                    `tx-normal tx-rubik tx-spacing--2 mg-b-5 tx-${item.systemMsg.systemClass}`
                                  "
                                >
                                  {{ item.count }}
                                </h3>
                                <!-- <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-10">{{item.systemMsg.systemTitle}}</h6> -->
                                <p class="mg-b-0 tx-12 tx-color-03">
                                  {{ item.systemMsg.systemMsg }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <table class="table table-dashboard mg-b-0">
                          <thead>
                            <tr>
                              <th>№</th>
                              <th>Нэвтрэх нэр</th>
                              <th class="text-end">Системийн хариу</th>
                              <!-- <th class="text-end">Gross Earnings</th>
                              <th class="text-end">Tax Withheld</th>
                              <th class="text-end">Net Earnings</th> -->
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(user, i) in filteredListImportUserInfo"
                              :key="`u${i}`"
                            >
                              <td class="tx-medium text-end">{{ user.i }}</td>
                              <td class="tx-medium text-end">
                                {{ user.loginName }}
                              </td>
                              <td :class="`tx-${user.systemClass} tx-normal`">
                                {{ user.systemMsg }}
                              </td>
                              <!-- <td class="text-end tx-teal">+ $32,580.00</td>
                              <td class="text-end tx-pink">- $3,023.10</td>
                              <td class="tx-medium text-end">$28,670.90 <span class="mg-l-5 tx-10 tx-normal tx-success d-inline-flex align-items-center"><ion-icon name="arrow-up-outline" class="mg-b-2 md hydrated" aria-label="arrow up outline" role="img"></ion-icon> 4.5%</span></td> -->
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </template>
                    <template v-else-if="field.flag === 181001">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <RadioGroup v-model="$data['taskModel'][field.field]">
                          <Radio :label="true">
                            <span>Тийм</span>
                          </Radio>
                          <Radio :label="false">
                            <span>Үгүй</span>
                          </Radio>
                        </RadioGroup>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 119">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <!-- {{ $data["taskModel"]["lat"] }} -->
                        <GmapMap
                          :center="{
                            lat:
                              $data['taskModel']['lat'] != null
                                ? parseFloat($data['taskModel']['lat'])
                                : 47.9138932,
                            lng:
                              $data['taskModel']['lng'] != null
                                ? parseFloat($data['taskModel']['lng'])
                                : 106.8986408,
                          }"
                          :zoom="13"
                          map-type-id="roadmap"
                          style="width: 100%; height: 300px"
                          @click="createMapMarkers(field.field, $event)"
                        >
                          <GmapMarker
                            v-for="(m, i) in getParsedPositions(
                              $data['taskModel'][field.field]
                            )"
                            :key="i"
                            :position="m.position"
                          />
                        </GmapMap>
                        <a
                          @click="$data['taskModel'][field.field] = '[]'"
                          class="btn btn-warning"
                          role="button"
                        >
                          цэвэрлэх
                        </a>

                        <!-- {{$data['taskModel'][field.field]}} -->
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 120">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <div class="btn-group">
                          <div @click="openeFormLinker(field)" class="btn btn-info">{{field.info!=null ? field.info : 'Шалгалт'}} холбох</div>
                          <div @click="$data['taskModel']['defaultFormId']=null" v-if="!($data['taskModel']['defaultFormId'] == '' || $data['taskModel']['defaultFormId'] == null || $data['taskModel']['defaultFormId'] == 0)" class="btn btn-warning">Холболт салгах [#{{$data['taskModel']['defaultFormId']}}]</div>
                          <!-- <div v-else class="btn btn-warning">{{$data['taskModel']['defaultFormId']}}</div> -->
                        </div>
                      <form-finder
                        v-if="showFormFinder"
                        :prms="finderParams"
                        @on-form-selected="linkForm"
                        @on-close="showFormFinder = false"
                      />
                      </FormItem>
                    </template>
                    <template v-else>
                      <div class="text-right" :key="`ddr${i}`">
                        {{ field.flag }}
                      </div>
                    </template>
                  </template>
                </Form>
              </div>
              <div v-show="currentTab == 2">
                <template v-for="(b, i) in taskDetail.b">
                  <loader
                    :ref="`box_${b.id}`"
                    :key="`b_${i}`"
                    :box="b"
                    :parentTask="taskDetail"
                    :prms="{ boxChooser: false }"
                    @show-edit="editShow($event)"
                    @on-attach="$emit('on-attach', $event)"
                  />
                </template>
              </div>
            </b-overlay>
          </div>
        </div>
        <template v-slot:footer>
          <div class="d-flex justify-content-between bd-t pd-y-10 pd-x-10">
            <a
              v-if="$store.state.app.activeGroup.id == 9233"
              href="http://help.vetdrug.mn/#/vet-landing-help/0/0"
              target="_blank"
              class="btn btn-uppercase btn-secondary text-white"
            >
              <feather type="help-circle" class="mg-r-5"></feather>
              <span>Заавар үзэх</span>
            </a>
            <a v-else target="_blank"></a>
            <!-- {{prms.objectTypeId}} -->

            <button
              @click="onSubmit(1, 101)"
              v-if="!datahandleLoading && directSaveOnly"
              class="btn btn-success"
              role="button"
            >
              Хадгалах
            </button>
            <template v-else>
              <b-overlay :show="datahandleLoading" rounded="sm">
                <div v-if="boxCount == 0">
                  <!-- <button
                    @click="onSubmit(1)"
                    variant="primary"
                    class="btn btn-xs btn-success btn-uppercase"
                  >
                    <feather type="check" class="ht-20-f wd-20-f mg-r-5"></feather>Хадгалах
                  </button>-->
                  <div class="dropdown">
                    <button
                      class="btn btn-xs btn-success dropdown-toggle"
                      type="button"
                      id="dropdownMenuForce"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Хадгалах
                    </button>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuForce"
                    >
                      <a
                        @click="onSubmit(1, 101)"
                        role="button"
                        class="dropdown-item"
                        >Хадгалах / Хаах</a
                      >
                      <a
                        @click="onSubmit(1, 102)"
                        role="button"
                        class="dropdown-item"
                        >Хадгалах / Шинэ</a
                      >
                      <a
                        v-show="prms.objectTypeId != 507"
                        @click="onSubmit(1)"
                        role="button"
                        class="dropdown-item"
                        >Хадгалах / Үргэлжлүүлэх</a
                      >
                      <a
                        v-show="prms.objectTypeId == 507"
                        @click="onSubmit(1, -99)"
                        role="button"
                        class="dropdown-item"
                        >Хадгалах / Дэлгэрэнгүй</a
                      >
                    </div>
                  </div>
                </div>
                <ul v-else class="steps steps-sm">
                  <li class="step-item" :class="{ active: currentTab == 1 }">
                    <a @click="currentTab = 1" class="step-link" role="button">
                      <span class="step-number">1</span>
                      <span class="step-title">Үндсэн мэдээлэл</span>
                    </a>
                  </li>
                  <li class="step-item" :class="{ active: currentTab == 2 }">
                    <a @click="onSubmit(1)" class="step-link" role="button">
                      <span class="step-number">2</span>
                      <span class="step-title">Бүрдэл</span>
                    </a>
                  </li>
                  <li class="step-item complete">
                    <div class="dropdown">
                      <button
                        class="btn btn-xs btn-success dropdown-toggle"
                        type="button"
                        id="dropdownMenuSave"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {{
                          currentTab === 1
                            ? "Хадгалах / Үргэлжлүүлэх"
                            : "Хадгалах / хаах"
                        }}
                      </button>
                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuSave"
                      >
                        <a
                          @click="onSubmit(currentTab, 101)"
                          role="button"
                          class="dropdown-item"
                          >Хадгалах / Хаах</a
                        >
                        <a
                          @click="onSubmit(currentTab, 102)"
                          role="button"
                          class="dropdown-item"
                          >Хадгалах / Шинэ</a
                        >
                        <a
                          @click="onSubmit(currentTab)"
                          class="dropdown-item"
                          role="button"
                          v-show="prms.objectTypeId != 507"
                          >{{
                            currentTab === 1
                              ? "Хадгалах / Үргэлжлүүлэх"
                              : "Хадгалах / Дэлгэрэнгүй"
                          }}</a
                        >
                      </div>
                    </div>
                    <!-- <button
                      @click="onSubmit(currentTab)"
                      class="btn btn-xs btn-success"
                      role="button"
                    >
                      <feather type="check" class="ht-20-f wd-20-f mg-r-5"></feather>
                      {{currentTab === 1 ?'Хадгалах / Үргэлжлүүлэх':'Хадгалах / хаах'}}
                    </button>-->
                  </li>
                </ul>
              </b-overlay>
              <button
                class="btn btn-xs btn-uppercase btn-danger"
                @click="visibleChanged(false)"
              >
                Хаах
              </button>
            </template>
          </div>
        </template>
      </b-sidebar>
    </template>

    <media-finder
      v-if="mediaFinder.show > 0"
      :fromCoreEdit="true"
      @on-attach="fileAttached"
      @on-task-close="mediaFinder.show = 0"
    ></media-finder>

    <action-dialog
      :id="actionDialog.id"
      :mode="actionDialog.mode"
      :key="actionDialog.key + '_ad'"
      :show="actionDialog.show"
      :task="taskDetail"
      :transferOptions="transferOptions"
      @on-hide="
        actionDialog.id = 0;
        actionDialog.show = false;
      "
      @on-transfered="
        actionDialog.id = 0;
        actionDialog.show = false;
      "
    />

    <b-modal
      width="1000"
      size="lg"
      hide-footer
      v-model="createdUser.modal"
      scrollable
      title="Хэрэглэгч сонгох"
    >
      <div>
        <table class="table-bordered table-striped wd-100p">
          <thead>
            <tr>
              <th>№</th>
              <th>Төрөл</th>
              <th>Нэр</th>
              <th>Нэвтрэх нэр (Бүртгэл №)</th>
              <th>Регистр №</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              @click="handleUserInfoModal(u.id)"
              v-for="(u, i) in createdUser.list"
              :key="i"
              role="button"
            >
              <td>{{ i + 1 }}</td>
              <td>{{ u.locType4Name }}</td>
              <td>{{ u.fullName }}</td>
              <td>{{ u.loginName }}</td>
              <td>{{ u.register }}</td>
              <td class="text-right pd-r-5 pd-y-5">
                <button
                  @click.stop="
                    assignScndUserId(u);
                    createdUser.modal = false;
                  "
                  type="button"
                  class="btn btn-outline-primary btn-xs"
                >
                  <span>Сонгох</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
const moment = require("moment");
import { hasOneOf } from "@/libs/tools";
import { request } from "@/api/all";
import { getEditFields } from "@/api/taskCore";
import { getColumnListByTaskId } from "@/api/column";
import { getInheritedTask, postInheritedTask } from "@/api/task";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import "element-ui/lib/theme-chalk/index.css";
import {
  Form,
  Input,
  FormItem,
  DatePicker,
  Divider,
  InputNumber,
  Select,
  OptionGroup,
  Option,
  Checkbox,
  RadioGroup,
  Radio,
  Notification,
} from "element-ui";

//import { mapActions } from "vuex";
import loader from "@/components/box/loader/loader.vue";
import { mapActions } from "vuex";
var _ = require("lodash");

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

import { filePreData, filePreviewDetail } from "@/api/media";

export default {
  name: "editBase",
  components: {
    VueCtkDateTimePicker,
    Form,
    FormItem,
    Input,
    DatePicker,
    Divider,
    InputNumber,
    Select,
    OptionGroup,
    Option,
    Checkbox,
    RadioGroup,
    Radio,
    loader,
    formFinder: () => ({
      component: import("@/views/modules/form/finder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskEdit: () => ({
      component: import("@/components/task/edit/base"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    accessFinder: () => ({
      component: import("@/components/task/edit/components/access"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskFinder: () => ({
      component: import("@/components/task/edit/components/taskFinder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskFinderSimple: () => ({
      component: import("@/components/task/edit/components/taskFinderSimple"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    mediaFinder: () => ({
      component: import("@/components/modules/media/finder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    vetClientUserOrgSelecter: () => ({
      component: import(
        "@/components/task/edit/components/vetClientUserOrgSelecter"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    crmUserDefaultCompanySelecter: () => ({
      component: import(
        "@/components/task/edit/components/crmUserDefaultCompanySelecter"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeJournal: () => ({
      component: import("@/components/task/edit/components/locTypeJournal"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeRadio: () => ({
      component: import("@/components/task/edit/components/locTypeRadio"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeCascaderAssignTaskOther: () => ({
      component: import(
        "@/components/task/edit/components/locTypeAssignTaskOther"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeCascaderAssignTask: () => ({
      component: import("@/components/task/edit/components/locTypeAssignTask"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeCascaderWithField: () => ({
      component: import("@/components/task/edit/components/locTypeWithField"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    loctypeMultipleTag: () => ({
      component: import("@/components/task/edit/components/locTypeMultipleTag"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypePanel: () => ({
      component: import(
        "@/components/task/edit/components/locTypeMultiplePanel"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    summernote: () => ({
      component: import("@/components/modules/editor/summernote"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    actionDialog: () => ({
      component: import("@/components/task/components/actions/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    hrmTagAssign: () => ({
      component: import("@/components/task/edit/components/hrmTagAssign"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    projectDropdown: () => ({
      component: import("@/components/project/components/dropdown.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    departCascader: () => ({
      component: import("@/components/modules/hr/departCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    departCascader2: () => ({
      component: import("@/components/modules/hr/departCascader2"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    specAssetChooser: () => ({
      component: import(
        "@/components/task/edit/components/specials/asset/flatChooser"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    specAssetListChooser: () => ({
      component: import(
        "@/components/task/edit/components/specials/asset/listChooser"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data: () => ({
    showFormFinder: false,
    finderParams: {
      mode: 50,
      objectTypeId: 500,
    },
    disableLocTypeCascaderWithField: false,
    directSaveOnly: false,
    ltFieldOnReset: false,
    createdUser: {
      mode: "1",
      value: "",
      list: [],
      modal: false,
      curId: 0,
      field: null,
    },
    showSidebar: false,
    fields: [],
    otConfig: {},
    hiddenFields: true,
    ready: false,
    taskModel: {},
    taskModelRdy: false,
    taskDetail: {},
    taskId: 0,
    currentTab: 1,
    savedResponse: {},
    globalError: false,
    directClose: false,

    taskEdit: {
      id: 0,
      show: false,
      render: false,
      objectTypeId: 0,
      projectId: 0,
      parentId: 0,
      parentTask: {},
    },
    datahandleLoading: false,
    boxCount: 0,
    mediaFinder: {
      show: false,
      obj: 0,
      mode: 1,
      key: 0,
    },
    locTypeFields: {
      draw: false,
      fields: [],
      model: {},
    },
    googleMapMaker: [],
    transferOptions: {
      taskColumns: [],
      canFinishTask: false,
      canReturnTask: false,
      canChangeProject: false,
      skipAfterColumn: {
        id: 0,
        name: "",
      },
      primaryTsoholt: false,
      hasAcceptColumn: false,
      hasAcceptObjectType: 0,
      isFirstColumn: false,
    },
    actionDialog: {
      id: 0,
      mode: null,
      key: 0,
      show: false,
    },

    myJoinedProjects: [],
    myJoinedProjectId: 0,
    columns: [],
    columnSelected: null,
    users: [],
    pinnedUsers: [],
    userSelected: [],
    departs: [],
    webComponents: [],
    erpGolomt: {
      sources: [],
      curValue: null,
    },
    fieldDataKey: 0,
    fieldDataFired: {
      organizationTaskId: false,
      locTypeId4: false,
    },
    locTypeId4IncrementKey: 0,
    importUserFromFileInfoData: {
      filterSystemFlag: null,
      users: [],
      grouped: [],
    },
  }),
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    wd: {
      type: String,
      default: () => "95%",
    },
    prms: {
      type: Object,
      default: () => {},
    },
    disablePreEditCheck: {
      type: Boolean,
      default: () => false,
    },
    labelPosition: {
      type: String,
      default: () => "left",
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    // whenever question changes, this function will run
    fieldDataKey: function(newValue, oldValue) {
      //console.log("watched", newValue, oldValue);
      if (
        this.fieldDataFired.organizationTaskId &&
        this.fieldDataFired.locTypeId4
      ) {
        if (this.prms.objectTypeId == 561) {
          if (
            this.fields.filter((x) => x.field == "organizationTaskId").length &&
            this.fields.filter((x) => x.field == "locTypeId4")
          ) {
            this.taskModel.locTypeId4 = this.fields.filter(
              (x) => x.field == "organizationTaskId"
            )[0].obj.locTypeId;

            this.locTypeFieldOnChange(
              this.taskModel.locTypeId4,
              "locTypeId4",
              true,
              true
            );
            this.$refs["ltCasWF_locTypeId4"][0].selectSelected(
              this.taskModel.locTypeId4
            );
          }
        }
      }
      //console.log(newQuestion, oldQuestion);
      //this.answer = 'Waiting for you to stop typing...'
      //this.fetchCalendarData();
    },
    deep: true,
  },
  computed: {
    filteredListImportUserInfo() {
      //const searchTerm = this.searchTerm.toLowerCase();
      const searchTerm = this.importUserFromFileInfoData.filterSystemFlag;
      if (searchTerm != null)
        return this.importUserFromFileInfoData.users.filter(
          (item) => item.systemFlag == searchTerm
        );
      else return this.importUserFromFileInfoData.users;
    },
  },
  methods: {
    vfdfgt(){
      
      let _fileTemplateProjectApply = this.$store.state.app.groupSettings.filter(x => x.key == "fileTemplateProjectApply");
      if (_fileTemplateProjectApply.length > 0 && _fileTemplateProjectApply[0].value != undefined) {
        filePreviewDetail({
          params: { id: _fileTemplateProjectApply[0].value },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            window.open(res.data.file.link, '_blank');
          }
        });
        // window.open(_fileTemplateProjectApply[0].value, '_blank');
      }
    },
    isFieldShow(field) {
      let rv= true;
      if(this.$store.state.app.activeGroup.id == 9379){
        if(field.field == "locTypeId2" && this.taskModel.objectTypeId == 340){
          rv = this.taskModel.locTypeId1 == 636966;
        }
      } else if(this.$store.state.app.activeGroup.id == 9298){
        if(this.taskModel.objectTypeId == 561){
          // console.log(this.taskModel.organizationTask.locTypeId)
          if(field.field == "taskEn"){
            rv = this.taskModel.organizationTask.locTypeId === 162063;
          } else if(field.field == "locTypeId5"){
            rv = this.hasPerr(["admin"]);
          }
        }
      }
      return rv;
    },
    openeFormLinker(field) {
      if(field.key!=null){
        this.finderParams.objectTypeId= parseInt(field.key);
      }
      this.showFormFinder= true
    },
    linkForm(f){
      if(f.length==1){
        this.$data["taskModel"]["defaultFormId"] = f[0];
      }else{

      }
      //console.log('link form', f);
      this.showFormFinder = false;
    },
    getParsedPositions(e) {
      if (e != null && e != undefined) {
        try {
          return JSON.parse(e);
        } catch {
          return [];
        }
      } else {
        return [];
      }
    },
    setFlag(systemFlag) {
      //console.log("setted");
      this.importUserFromFileInfoData.filterSystemFlag = systemFlag;
    },
    onJournalSelcd(e) {
      this.taskModel.locTypeId14 = e.locTypeId14;
      this.taskModel.locTypeId15 = e.locTypeId15;
    },
    ...mapActions(["handleUserInfoModal", "handleLoading"]),
    hideThisSpecial() {
      let rv = true;
      //console.log('dsf', this.taskModel.locTypeId4);
      if (
        this.taskModel.locTypeId4 == 251286 ||
        this.taskModel.locTypeId4 == 162068
      ) {
        rv = false;
      }
      //if()
      return rv;
    },
    simplUpldrHasDrive() {
      let rv = true;
      if (this.$store.state.app.activeGroup.id == 9298) {
        if (this.hasPerr(["stf_proj_sudlaach"]) && !this.hasPerr(["admin"])) {
          rv = false;
        }
      }
      return rv;
    },
    locTypeCascaderOnDataFired(field) {
      //console.log("locTypeCascaderOnDataFired", field);
      if (field.field == "locTypeId4") {
        this.fieldDataFired.locTypeId4 = true;
        this.fieldDataKey = this.fieldDataKey + 1;
      }
    },
    onTaskSelected(field, event) {
      field.cstmFld2 = event.task;
      field.obj = event;
      if (field.field == "organizationTaskId") {
        //console.log("organizationTaskIdFired", field);
        this.fieldDataFired.organizationTaskId = true;
        this.fieldDataKey = this.fieldDataKey + 1;
      }

      //console.log(this.prms.objectTypeId, event.locTypeId)
    },
    onTaskSelectedSimple(field, event) {
      //console.log('event', event);
      if (event != null) {
        field.cstmFld2 = event.task;
        this.$data["taskModel"][field.field] = event.id;
      } else {
        field.cstmFld2 = null;
        this.$data["taskModel"][field.field] = null;
      }
      //console.log('onTaskSelectedSimple', field, event);

      //field.obj = event;

      // if (field.field == "organizationTaskId") {
      //   //console.log("organizationTaskIdFired", field);
      //   this.fieldDataFired.organizationTaskId = true;
      //   this.fieldDataKey = this.fieldDataKey + 1;
      // }

      //console.log(this.prms.objectTypeId, event.locTypeId)
    },
    departCascader2Changed(f, e) {
      this.$data["taskModel"]["departId2"] = e;
    },
    locTypePanelOnChange(e) {
      //console.log("locTypePanelOnChange", e);
    },
    radioValueChanged(field, e) {
      this.$nextTick(() => {
        this.$data["taskModel"][field] = e;
        this.$refs.formValidate.validateField(field);
      });
    },
    init() {
      this.showSidebar = true;
      this.taskId = this.prms.id;

      let preEditId = this.prms.id;
      if (preEditId == 0) {
        preEditId = -1;
      }
      if (this.disablePreEditCheck) {
        this.build();
      } else {
        request({
          api: { url: "task/PreEdit", method: "get" },
          params: {
            id: preEditId,
            parentId: this.prms.parentId,
            boxId: this.prms.boxId,
            objectTypeId: this.prms.objectTypeId,
            projectId: this.prms.projectId,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.build();
          } else {
            this.visibleChanged(false);
          }
        });
      }
    },
    hasPerr(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    // formValidated(e){
    //   //console.log("formValidated",e);
    // },
    buildAfter() {
      if (
        (this.$store.state.app.activeGroup.id == 9241 ||
          this.$store.state.app.activeGroup.id == 9249) &&
        (this.prms.objectTypeId == 115 || this.prms.objectTypeId == 396)
      ) {
        let _url = "";
        if (this.prms.objectTypeId == 115) {
          _url = "open/learn/trainingList";
        } else if (this.prms.objectTypeId == 396) {
          _url = "open/learn/teacherList";
        }
        this.datahandleLoading = true;
        request({
          api: { url: _url, method: "get" },
          store: this.$store,
        }).then((res) => {
          this.datahandleLoading = false;
          if (res != false) {
            this.erpGolomt.sources = res.data.list;
          }
        });
      } else if (this.$store.state.app.activeGroup.id == 9298) {
        if (
          this.hasPerr(["stf_proj_sudlaach"]) &&
          !this.hasPerr(["stf_proj_shinjeech"]) &&
          !this.hasPerr(["stf_proj_admin"])
        ) {
          this.directSaveOnly = true;
        }

        if (this.prms.objectTypeId == 377 && !this.hasPerr(["admin"])) {
          this.fields.forEach((f) => {
            if (f.field == "locTypeId2") {
              f.flag = 37701;
            }
            // console.log('f', f);
          });
        }
      } else if (this.$store.state.app.activeGroup.id == 9344) {
        if (this.prms.objectTypeId == 181) {
          this.fields.forEach((f) => {
            if (f.field == "isRepeat" || f.field == "isPublic") {
              f.flag = 181001;
            }
          });
        } else if (this.prms.objectTypeId == 138) {
          this.fields.forEach((f) => {
            if (f.field == "langCode") {
              f.flag = null;
            }
          });
        }
      }
    },
    getInheritedTaskAfter(task) {
      //console.log(task)
      if (
        this.prms.parentTask != undefined &&
        this.prms.parentTask.fromAsset != undefined
      ) {
        this.taskModel.st1 = this.prms.parentTask.st1;
        this.taskModel.dueStartDate = this.prms.parentTask.dueStartDate;
        this.taskModel.dueDate = this.prms.parentTask.dueDate;

        this.taskModel.locTypeId5 = this.prms.parentTask.locTypeId5;
        this.taskModel.locTypeId6 = this.prms.parentTask.locTypeId6;
        this.taskModel.locTypeId7 = this.prms.parentTask.locTypeId7;
        this.taskModel.locTypeId8 = this.prms.parentTask.locTypeId8;
      }

      if (
        this.taskModel.id == 0 &&
        this.prms.parentTask != null &&
        this.taskModel.objectTypeId == 508
      ) {
        this.taskModel.organizationTaskId = this.prms.parentTask.organizationTaskId;
        this.taskModel.secondOrganizationTaskId = this.prms.parentTask.secondOrganizationTaskId;
      }

      // console.log("step 1");
      if (this.prms.fillAfter != undefined && task.id <= 0) {
        // console.log("step 2");
        if (
          this.prms.fillAfter.organizationTaskId != undefined &&
          this.prms.fillAfter.organizationTaskId > 0
        ) {
          this.taskModel.organizationTaskId = this.prms.fillAfter.organizationTaskId;
        }

        if (
          this.prms.fillAfter.locTypeId != undefined &&
          this.prms.fillAfter.locTypeId > 0
        ) {
          this.taskModel.locTypeId = this.prms.fillAfter.locTypeId;
        }

        if (
          this.prms.fillAfter.d1 != undefined &&
          this.prms.fillAfter.d1 != ""
        ) {
          this.taskModel.d1 = this.prms.fillAfter.d1;
        }
      }

      if (
        this.$store.state.app.activeGroup.id == 9298 &&
        this.prms.objectTypeId == 561
      ) {
        //console.log('fgd', this.taskModel.organizationTask);
        if (this.taskModel.organizationTask != null) {
          if (
            this.taskModel.organizationTask.locTypeId == 251286 ||
            this.taskModel.organizationTask.locTypeId == 162068
          ) {
            let _decfs = [];

            _decfs.push("locTypeId2");
            _decfs.push("locTypeId5");
            _decfs.push("locTypeId6");
            _decfs.push("divider1");
            _decfs.push("locTypeIds2");
            _decfs.push("taskDesc");
            _decfs.push("s1");
            _decfs.push("s2");
            _decfs.push("defaultAttachmentId");
            _decfs.push("secondAttachmentId");
            _decfs.push("s3");
            _decfs.push("s4");
            _decfs.push("s5");
            _decfs.push("s6");
            //_decfs.push('locTypeId4');

            // _decfs.push('locTypeId7');
            // _decfs.push('task');

            //# 251286 - Гарааны компаны инновацийн төсөл
            //# 162068 - Инновацийн төслийн бүртгэл
            //console.log('step 1 bnu', this.taskModel.organizationTask.locTypeId==251286);
            if (this.taskModel.organizationTask.locTypeId == 251286) {
              _decfs.push("dueStartDate");
              _decfs.push("dueDate");
            } else if (this.taskModel.organizationTask.locTypeId == 162068) {
              _decfs.push("locTypeId7");
            }

            this.fields = this.fields.filter(
              (x) => !hasOneOf([x.field], _decfs)
            );
          } else {
            let _decfs = [];
            _decfs.push("locTypeId7");
            this.fields = this.fields.filter(
              (x) => !hasOneOf([x.field], _decfs)
            );
          }
        }
        //   if()
        //   this.fields = this.fields.filter((x) => x.flag != 81);
      }

      //taskModel.id==0? prms.parentTask !=null? prms.parentTask.organizationTaskId : null : $data['taskModel']['organizationTaskId']
    },
    build() {
      let self = this;
      //console.log(this.prms.projectId);

      let buildProjectId = this.prms.projectId;

      getEditFields({
        params: { objectTypeId: this.prms.objectTypeId },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          res.data.fields
            .filter((x) => x.flag === 85)
            .forEach((e) => {
              e.cstmFld1 = false;
            });
          this.fields = res.data.fields;

          if (this.$store.state.app.activeGroup.id == 9298) {
            if (this.prms.objectTypeId == 138) {
              this.fields = this.fields.filter((x) => x.flag != 51);
            } else if (this.prms.objectTypeId == 140) {
              // console.log(this.fields);
              // if(hasOneOf(['zuvlul.stf.gov.mn'], this.$store.state.app.activeGroup.hostPro)){
              //   this.fields = this.fields.filter((x) => x.flag != 51);
              // }
            } else if (this.prms.objectTypeId == 316) {
              if (
                hasOneOf(
                  ["zuvlul.stf.gov.mn"],
                  this.$store.state.app.activeGroup.hostPro
                )
              ) {
                this.fields = this.fields.filter(
                  (x) => !hasOneOf([x.field], ["locTypeId", "locTypeId1"])
                );
              }
            }
            //console.log('fields 1', this.fields);
          }

          this.otConfig = res.data.ot;
          if (this.otConfig.editViewType > 0) {
            this.fields.push({
              flag: 88888,
              editOrd: this.otConfig.editViewType - 0.5,
            });
          } else {
            this.hiddenFields = false;
          }
          this.fields = _.orderBy(this.fields, ["editOrd"], ["asc"]);
          this.buildAfter();

          if (this.fields.filter((x) => x.flag === 39).length > 0) {
            let fld = this.fields.filter((x) => x.flag === 39)[0];
            let prj = this.$store.state.app.groupDefaultProjects.filter(
              (x) => x.objectTypeId == parseInt(fld.key, 10)
            );
            if (prj.length > 0) buildProjectId = prj[0].id;
          }

          if (this.fields.length == 0) {
            this.$bvToast.toast(`Шинэ мэдээлэл оруулах боломжгүй байна.`, {
              title: "Мэдэгдэл",
              autoHideDelay: 3000,
              appendToast: true,
              variant: "warning",
              toaster: "b-toaster-bottom-left",
            });
            this.visibleChanged(false);
          }
          getInheritedTask({
            params: {
              id: this.prms.id,
              parentId: this.prms.parentId,
              boxId: this.prms.boxId,
              objectTypeId: this.prms.objectTypeId,
              projectId: buildProjectId,
            },
            store: this.$store,
          }).then((res) => {
            if (this.prms.id == 0 && this.prms.objectTypeId == 138) {
              res.data.task.userRegisterOptionModel = {
                approveRequiredGroupInUser: false,
                approveRequired: false,
                hasDefaultPassword: true,
                disableApproveMail: true,
              };
              res.data.task.systemFlag = 1;
            }

            if (this.prms.objectTypeId == 561) {
              this.disableLocTypeCascaderWithField = true;
            }

            //console.log(this.prms.objectTypeId);
            if (
              this.$route.params.ot == 390 ||
              this.prms.objectTypeTmpId == 390
            ) {
              //console.log("sys 6")
              res.data.task.systemFlag = 6;
            }

            if (
              res.data.task.locTypeId > 0 &&
              res.data.task.ltFields.length > 0
            ) {
              this.locTypeFieldOnChange(
                res.data.task.locTypeId,
                "locTypeId",
                true,
                true
              );
            }

            if (
              res.data.task.locTypeId4 > 0 &&
              res.data.task.ltFields != null &&
              res.data.task.ltFields.length > 0
            ) {
              this.locTypeFieldOnChange(
                res.data.task.locTypeId4,
                "locTypeId4",
                true,
                true
              );
            }

            // if (this.prms.id != 0 && hasOneOf([496, 509], [this.prms.objectTypeId])) {
            //   if (res.data.task.lat != null && res.data.task.lng != null) {
            //     this.createMapMarkerForce(res.data.task);
            //   }
            // }
            if (
              this.prms.id != 0 &&
              res.data.task.lat != null &&
              res.data.task.lng != null
            ) {
              this.createMapMarkerForce(res.data.task);
            }

            if (
              this.prms.directData != undefined &&
              this.prms.directData.organizationTaskId != undefined
            ) {
              res.data.task.organizationTaskId = this.prms.directData.organizationTaskId;
            }

            if (
              this.prms.directData != undefined &&
              this.prms.directData.secondOrganizationTaskId != undefined
            ) {
              res.data.task.secondOrganizationTaskId = this.prms.directData.secondOrganizationTaskId;
            }

            if (this.fields.filter((x) => x.flag === 42).length > 0) {
              request({
                api: { url: "task/getTasksByOT", method: "get" },
                params: { ot: 355, size: 100, page: 0, parentId: 0 },
                store: this.$store,
              }).then((res) => {
                this.webComponents = res.data.tasks.filter(
                  (x) => x.parentId == 0
                );
              });
            }

            this.taskModel = res.data.task;

            this.taskModel["field_227"] = "";
            this.taskModelRdy = true;

            this.fields
              .filter((x) => x.dataTypeId === 5)
              .forEach((e) => {
                if (self.taskModel[e.field] != null) {
                  // self.taskModel[e.field] = moment(
                  //   self.taskModel[e.field]
                  // ).toDate();

                  self.taskModel[e.field] = moment(
                    self.taskModel[e.field]
                  ).format("YYYY-MM-DD HH:mm:ss");
                }
              });

            if (
              this.taskModel.objectTypeId > 0 &&
              this.taskModel.projectId > 0
            ) {
              this.projSelected({
                ot: this.taskModel.objectTypeId,
                id: this.taskModel.projectId,
                first: true,
              });
            }

            if (this.fields.filter((x) => x.flag === 39).length > 0) {
              let fld = this.fields.filter((x) => x.flag === 39)[0];
              let prj = this.$store.state.app.groupDefaultProjects.filter(
                (x) => x.objectTypeId == parseInt(fld.key, 10)
              );
              if (prj.length > 0) this.taskModel.projectId = prj[0].id;
            }

            if (this.prms.id == 0) {
              // console.log('step 1 vv', this.prms);
              this.ready = true;
            } else {
              request({
                api: { url: "task/taskInheritedDetail", method: "get" },
                params: { id: this.prms.id },
                store: this.$store,
              }).then((res) => {
                if (res != false) {
                  this.taskDetail = res.data.task;
                  // if(this.prms.objectTypeId==377){
                  //   console.log('this.taskDetail.locTypeId1', this.taskDetail.locTypeId1);
                  //   this.$refs.rf_37701.taskModel.locTypeId1= this.taskDetail.locTypeId1;
                  // }

                  this.taskDetail.b
                    .filter((x) => x.ot == 124)
                    .map((b) => {
                      b.otCompName = "coreBox";
                    });
                  this.taskDetail.b
                    .filter(
                      (x) =>
                        x.ot == 389 ||
                        x.ot == 116 ||
                        x.ot == 117 ||
                        x.ot == 416 ||
                        x.ot == 503
                    )
                    .map((b) => {
                      b.otCompName = "system/form";
                    });

                  this.taskDetail.b
                    .filter((x) => x.ot == 286 || x.ot == 123)
                    .map((b) => {
                      b.otCompName = "system/attachment";
                    });
                  this.taskDetail.b
                    .filter(
                      (x) =>
                        x.ot == 389 ||
                        x.ot == 116 ||
                        x.ot == 117 ||
                        x.ot == 416 ||
                        x.ot == 503
                    )
                    .map((b) => {
                      b.otCompName = "system/form";
                    });

                  this.boxCount = this.taskDetail.b.length;
                  this.ready = true;
                } else {
                  this.globalError = true;
                }
              });
            }

            this.getInheritedTaskAfter(this.taskModel);
          });
        }
      });
    },
    projSelected(prms) {
      this.taskModel.objectTypeId = prms.ot;
      this.taskModel.projectId = prms.id;
      //console.log(prms.id)
      // this.showSpin = true;
      // GetProjectTaskEditPreTemplateData({
      //   projectId: prms.id
      // }).then(res => {
      //   this.templateModel = res.data;
      //   if (res.data.hasTemplatePrefix) {
      //     if(this.taskModel.id==0)
      //     this.taskModel.prefix = res.data.prefix;
      //     this.taskModel.dueStartEnd = [];
      //     this.taskModel.dueStartEnd.push(this.taskModel.dueStartDate);
      //     this.taskModel.dueStartEnd.push(res.data.dueDate);

      //     if (prms.first) {
      //       if(this.taskModel.id==0)
      //       this.firstModel.prefix = res.data.prefix;
      //       this.firstModel.dueStartEnd = [];
      //       this.firstModel.dueStartEnd.push(this.firstModel.dueStartDate);
      //       this.firstModel.dueStartEnd.push(res.data.dueDate);
      //       this.handleCoreEditFreezeModel({ model: this.firstModel }).then(
      //         res => {}
      //       );
      //     }
      //   }
      // });
      request({
        api: { url: "Column/GetColumnListByProjectId", method: "get" },
        params: { projectId: prms.id },
        store: this.$store,
      }).then((res) => {
        this.columns = res.data.columns;

        // if (this.taskModel.currentColumnId > 0) {
        //   this.columnSelected = this.taskModel.currentColumnId;
        // } else {
        //   if (this.columns.length > 0) this.columnSelected = this.columns[0].id;
        // }
      });
    },
    infoBuilder(v) {
      if (v == null) {
        return "";
      } else if (v.length <= 0) {
        return "";
      } else {
        return v;
      }
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    fetchImportUserFromFileInfo(attachmentId) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { url: "Auth/ImportUserFromFileInfo", method: "post" },
        data: { attachmentId: attachmentId },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.importUserFromFileInfoData = res.data;
          this.importUserFromFileInfoData.filterSystemFlag = null;
        }
      });
    },
    fileUploaded(e, field) {
      field.uv = false;
      this.$data["taskModel"][field.key] = e.uploadedName;
      this.$data["taskModel"][field.field] = e.uploadedAttachmentId;
      field.cstmFld1 = e.uploadedUrl;

      if (this.taskModel.objectTypeId == 461) {
        this.fetchImportUserFromFileInfo(e.uploadedAttachmentId);

        //importUserFromFileInfoData.users
      }
    },
    fileUploadedProperty(e, field) {
      // console.log('before', field);
      // field.push(e.uploadedAttachmentId);
      // console.log('aftr', field);
      // field.uv = false;
      // this.$data["taskModel"][field.key] = e.uploadedName;
      // this.$data["taskModel"][field.field] = e.uploadedAttachmentId;
      // field.cstmFld1 = e.uploadedUrl;

      this.locTypeFieldOnSet(
        field.property.type,
        e.uploadedAttachmentId,
        field
      );
    },
    fileAttached(e) {
      if (this.mediaFinder.mode == 2) {
        //console.log(this.locTypeFields.fields);
        //console.log(this.mediaFinder.obj);
        let i = this.locTypeFields.fields
          .map((f) => f.id)
          .indexOf(this.mediaFinder.obj["id"]);
        //console.log('index olson ni', i);
        //console.log('index olson ni', this.locTypeFields.fields[i]);
        //this.locTypeFields.fields[i].property['selectedValues'].push(e.id);
        this.locTypeFieldOnSet(
          this.locTypeFields.fields[i].property.type,
          e.id,
          this.locTypeFields.fields[i]
        );
      } else {
        this.$data["taskModel"][this.mediaFinder.obj["key"]] = e.t;
        this.$data["taskModel"][this.mediaFinder.obj["field"]] = e.id;

        if (this.taskModel.objectTypeId == 461) {
          this.fetchImportUserFromFileInfo(e.id);

          //importUserFromFileInfoData.users
        }
      }

      //this.featherReplace();
      this.mediaFinder.show = false;
    },

    locTypeFieldOnChange(e, f, fromInherited, isFirst) {
      //console.log("this is a change", e, f, fromInherited, isFirst);
      let self = this;
      if (!isFirst) this.ltFieldOnReset = true;
      if (e > 0) {
        request({
          api: { url: "Ltdb/GetFields", method: "get" },
          params: { locTypeId: e },
          store: this.$store,
        }).then((res) => {
          this.locTypeFields.fields = res.data.fields.map(function(e) {
            if (e.property.type == 3) {
              e.property.value = "";
            } else if (e.property.type == 5) {
              e.property.value = null;
            } else {
              e.property.value = [];
            }
            return e;
          });
          //this.taskModel.ltFields = null;
          if (!fromInherited) this.taskModel.ltFields = null;
          if (this.taskModel.ltFields != null) {
            for (var i = 0; i < this.taskModel.ltFields.length; i++) {
              for (
                var pi = 0;
                pi < this.taskModel.ltFields[i].property.selectedValues.length;
                pi++
              ) {
                let _orp = this.taskModel.ltFields[i].property.selectedValues[
                  pi
                ];
                // console.log('stepp 0');
                // if (
                //   self.locTypeFields.fields.filter(
                //     (x) => x.id == _orp.propertyId
                //   ).length
                // ) {
                //   console.log('ene mun vvvvvvvvv');
                // }

                if (
                  self.locTypeFields.fields.filter(
                    (x) => x.id == _orp.propertyId
                  ).length &&
                  (self.locTypeFields.fields.filter(
                    (x) => x.id == _orp.propertyId
                  )[0].property.type == 3 ||
                    self.locTypeFields.fields.filter(
                      (x) => x.id == _orp.propertyId
                    )[0].property.type == 4 ||
                    self.locTypeFields.fields.filter(
                      (x) => x.id == _orp.propertyId
                    )[0].property.type == 5 ||
                    self.locTypeFields.fields.filter(
                      (x) => x.id == _orp.propertyId
                    )[0].property.type == 6)
                ) {
                  //console.log('step 111');
                  if (
                    self.locTypeFields.fields.filter(
                      (x) => x.id == _orp.propertyId
                    )[0].property.type == 4
                  ) {
                    //console.log('step 112', _orp.value);
                    self.locTypeFields.fields.filter(
                      (x) => x.id == _orp.propertyId
                    )[0].property.selectedValues = [parseInt(_orp.value, 10)];
                  } else if (
                    self.locTypeFields.fields.filter(
                      (x) => x.id == _orp.propertyId
                    )[0].property.type == 6
                  ) {
                    //console.log('step 6666666666666666666666666666666666666', _orp.value);
                    self.locTypeFields.fields.filter(
                      (x) => x.id == _orp.propertyId
                    )[0].property.selectedValues = [parseInt(_orp.value, 10)];
                    self.locTypeFields.fields.filter(
                      (x) => x.id == _orp.propertyId
                    )[0].property.value = parseInt(_orp.value, 10);
                  } else if (
                    self.locTypeFields.fields.filter(
                      (x) => x.id == _orp.propertyId
                    )[0].property.type == 5
                  ) {
                    self.locTypeFields.fields.filter(
                      (x) => x.id == _orp.propertyId
                    )[0].property.selectedValues = [
                      moment(_orp.value).format("YYYY-MM-DD HH:mm:ss"),
                    ];
                  } else {
                    self.locTypeFields.fields.filter(
                      (x) => x.id == _orp.propertyId
                    )[0].property.selectedValues = [_orp.value];
                  }
                } else if (
                  self.locTypeFields.fields.filter(
                    (x) => x.id == _orp.propertyId
                  ).length &&
                  self.locTypeFields.fields.filter(
                    (x) => x.id == _orp.propertyId
                  )[0].property.type == 1
                ) {
                  self.locTypeFields.fields.filter(
                    (x) => x.id == _orp.propertyId
                  )[0].property.selectedValues = _orp.id;
                  self.locTypeFields.fields.filter(
                    (x) => x.id == _orp.propertyId
                  )[0].property.value = _orp.id;
                } else if (
                  self.locTypeFields.fields.filter(
                    (x) => x.id == _orp.propertyId
                  ).length &&
                  self.locTypeFields.fields.filter(
                    (x) => x.id == _orp.propertyId
                  )[0].property.type == 2
                ) {
                  self.locTypeFields.fields
                    .filter((x) => x.id == _orp.propertyId)[0]
                    .property.selectedValues.push(_orp.id);
                  self.locTypeFields.fields
                    .filter((x) => x.id == _orp.propertyId)[0]
                    .property.value.push(_orp.id);
                }

                // let propXXX = self.locTypeFields.fields.filter(
                //     (x) => x.id == _orp.propertyId
                //   );

                // if(propXXX.length && isFirst){
                //   //console.log("dahisan uu")
                //   propXXX = propXXX[0];
                //   if(propXXX.property.type==1 || propXXX.property.type==2)
                //     this.taskModel['field_'+this.taskModel.ltFields[i].id] = propXXX.property.value;
                //   else if(this.taskModel.id==0)
                //     this.taskModel['field_'+this.taskModel.ltFields[i].id] = propXXX.property.value;
                //   else
                //     this.taskModel['field_'+this.taskModel.ltFields[i].id] = propXXX.property.selectedValues[0];
                //     //console.log(this.taskModel['field_'+this.taskModel.ltFields[i].id])

                // }
              }
            }
          } else {
            this.taskModel.ltFields = res.data.fields;
          }
        });
      }

      this.$data["taskModel"][f] = e;
      this.locTypeFields.draw = e != null;
    },
    locTypeFieldOnSet(mode, value, field) {
      //console.log("locTypeFieldOnSet", mode, value, field)
      if (mode == 6) {
        //# values olgoj bgaa ni
        let _vls =
          value == null
            ? []
            : [
                {
                  id: 0,
                  propertyId: field.property.id,
                  value: value,
                  doubleValue: 0,
                  ord: 10,
                },
              ];

        //# zurg bgaa giin field model
        field.property.selectedValues = _vls;
        field.property.value = value;

        //# post r hadgalah datad olgoj bgaa ni
        let _ltf = this.taskModel.ltFields.filter((x) => x.id == field.id);
        if (_ltf.length > 0) {
          _ltf[0].property.selectedValues = _vls;
          _ltf[0].property.value = value;
        }
      } else {
        if (value != undefined) {
          this.taskModel["field_" + field.id] = value;
          //console.log(this.taskModel);
          let _sf = [];
          if (mode == 1) {
            _sf = field.property.values.filter((x) => x.id == value);
          } else if (mode == 2) {
            _sf = field.property.values.filter((x) => hasOneOf([x.id], value));
          }

          let _ltf = [];
          //console.log(this.taskModel.ltFields);
          _ltf = this.taskModel.ltFields.filter((x) => x.id == field.id);
          //console.log(_ltf)
          if (_sf.length > 0) {
            if (_ltf.length > 0) {
              if (mode == 1 || mode == 6) {
                //console.log('end irev uu')
                _ltf[0].property.selectedValues = [_sf[0]];
                _ltf[0].property.value = _sf[0].id;
                //console.log('end irev uu', _ltf[0].property.value)
              } else if (mode == 2) {
                _ltf[0].property.selectedValues = _sf;
              }
            }
          } else if (mode == 3 || mode == 4 || mode == 5) {
            //console.log('dr ', _ltf.length);
            if (_ltf.length > 0) {
              //console.log('dr 2=>', _ltf);
              _ltf[0].property.selectedValues = [
                {
                  id: 0,
                  propertyId: field.property.id,
                  //value: mode == 3 ? value.target.value : value,
                  value: value,
                  doubleValue: 0,
                  ord: 10,
                },
              ];
            }
          } else if (mode == 6) {
            // console.log('zovhon 6 uyed ene ajillana')
            field.property.selectedValues = [
              {
                id: 0,
                propertyId: field.property.id,
                //value: mode == 3 ? value.target.value : value,
                value: value,
                doubleValue: 0,
                ord: 10,
              },
            ];
            field.property.value = value;
            // console.log('zovhon 6 uyed ene ajillana', field)
          }
          // else if (mode == 6) {
          //   //console.log('dr ', _ltf.length);
          //   if (_ltf.length > 0) {
          //     //console.log(_ltf);
          //     if(value > 0){
          //       // console.log('stp 333');
          //       //_ltf[0].property.selectedValues = [ value ];
          //       field.property.selectedValues = [ value ];
          //     }else {
          //       // console.log('stp 444', field);
          //       // console.log('stp 445', _ltf[0].property);
          //       // _ltf[0].property.selectedValues = [];
          //       // console.log('stp 446', _ltf[0].property);

          //       field.property.selectedValues = [];
          //     }
          //   }
          // }
        } else {
          if (mode == 6) {
            // console.log('zovhon 6 uyed ene ajillana ene bol null shu')
            field.property.selectedValues =
              value == null
                ? []
                : [
                    {
                      id: 0,
                      propertyId: field.property.id,
                      //value: mode == 3 ? value.target.value : value,
                      value: value,
                      doubleValue: 0,
                      ord: 10,
                    },
                  ];
            field.property.value = value;
            // console.log('zovhon 6 uyed ene ajillana ene bol null shu', field)
          }
          // console.log('value ni ene shde', value);
        }
      }
    },

    onSubmit(submitMode, afterMode) {
      //console.log('onSubmit=> ', submitMode, afterMode);
      this.datahandleLoading = true;
      //console.log(        this.$data["taskModel"]["locTypeIds"],        this.$data["taskModel"]["objectTypeId"]      );
      if (
        this.$store.state.app.activeGroup.id == 9298 &&
        (this.$data["taskModel"]["objectTypeId"] == 138 ||
          this.$data["taskModel"]["objectTypeId"] == 561) &&
        this.$data["taskModel"]["locTypeIds"].length > 1500
      ) {
        this.datahandleLoading = false;
        this.$bvToast.toast(
          `түлхүүр үг хамгийн ихдээ 1500-г сонгох боломжтой`,
          {
            title: "Амжилтгүй",
            autoHideDelay: 3000,
            appendToast: true,
            variant: "warning",
            toaster: "b-toaster-bottom-left",
          }
        );
      } else if (submitMode == 2) {
        this.datahandleLoading = false;
        this.$emit("on-task-posted", {
          obj: this.taskModel,
          prms: this.prms,
        });
      } else {
        let ltValid = true;
        let ltErrs = [];
        if (this.taskModel.ltFields != null && this.taskModel.ltFields.length) {
          this.taskModel.ltFields.forEach((ltf) => {
            if (
              ltf.property.required &&
              (ltf.property.value == null || ltf.property.value == "")
            ) {
              //console.log('ltf is', ltf);
              ltErrs.push(ltf.property.requiredText);
              ltf.property.isValid = false;

              this.locTypeFields.fields.filter(
                (x) => x.id == ltf.property.id
              )[0].isValid = false;
            } else {
              this.locTypeFields.fields.filter(
                (x) => x.id == ltf.property.id
              )[0].isValid = true;
              ltf.property.isValid = true;
            }
            //ltValid=false;
            //console.log(ltf);
          });
        }
        //return false;
        //  if(ltErrs.length){

        //   ltValid=false;
        //  }

        this.$refs.formValidate.validate((valid) => {
          if (valid && ltValid) {
            postInheritedTask({
              data: { model: this.taskModel },
              store: this.$store,
            }).then((res) => {
              if (res.result == 1) {
                this.directClose = true;

                if (submitMode == 1) {
                  this.taskModel.id = res.taskId;
                  this.taskId = res.taskId;
                  this.savedResponse = res;
                  if (this.prms.id == 0) {
                    request({
                      api: { url: "task/taskInheritedDetail", method: "get" },
                      params: { id: this.taskId },
                      store: this.$store,
                    }).then((res) => {
                      this.datahandleLoading = false;
                      if (res != false) {
                        this.taskDetail = res.data.task;
                        if (this.taskDetail.objectTypeId == 498) {
                          this.setTransferOptions(this.taskDetail.id);
                        }
                        //console.log('step 0');
                        if (this.taskDetail.b.length == 0) {
                          //console.log('step 1');
                          this.datahandleLoading = false;
                          this.$emit("on-task-posted", {
                            obj: this.taskModel,
                            prms: this.prms,
                            afterMode:
                              afterMode != undefined ? afterMode : null,
                          });
                          Object.assign(this.$data, this.$options.data());
                        } else {
                          //console.log('step 2');
                          this.taskDetail.b
                            .filter((x) => x.ot == 124)
                            .map((b) => {
                              b.otCompName = "coreBox";
                            });
                          this.taskDetail.b
                            .filter(
                              (x) =>
                                x.ot == 389 ||
                                x.ot == 116 ||
                                x.ot == 117 ||
                                x.ot == 416 ||
                                x.ot == 503
                            )
                            .map((b) => {
                              b.otCompName = "system/form";
                            });

                          this.taskDetail.b
                            .filter((x) => x.ot == 286 || x.ot == 123)
                            .map((b) => {
                              b.otCompName = "system/attachment";
                            });
                          this.taskDetail.b
                            .filter(
                              (x) =>
                                x.ot == 389 ||
                                x.ot == 116 ||
                                x.ot == 117 ||
                                x.ot == 416 ||
                                x.ot == 416
                            )
                            .map((b) => {
                              b.otCompName = "system/form";
                            });

                          this.boxCount = this.taskDetail.b.length;

                          if (afterMode != undefined) {
                            //console.log('shine yed end vv', afterMode);
                            if (
                              afterMode == 101 ||
                              afterMode == 102 ||
                              afterMode == -99
                            ) {
                              this.$emit("on-task-posted", {
                                obj: this.taskModel,
                                prms: this.prms,
                                afterMode: afterMode,
                              });
                              Object.assign(this.$data, this.$options.data());
                            }
                          } else {
                            this.currentTab = 2;
                          }
                        }
                      } else {
                        this.globalError = true;
                      }
                    });
                  } else {
                    //console.log('zasaj bgaa yed end vv', afterMode, this.boxCount);
                    this.datahandleLoading = false;
                    //if (this.boxCount == 0) {
                    if (
                      this.boxCount == 0 ||
                      afterMode == 101 ||
                      afterMode == 102 ||
                      afterMode == -99
                    ) {
                      this.$emit("on-task-posted", {
                        obj: this.taskModel,
                        prms: this.prms,
                        afterMode: afterMode,
                      });
                    } else {
                      this.currentTab = 2;
                    }
                  }
                } else if (submitMode == 2) {
                  this.datahandleLoading = false;
                  this.$emit("on-task-posted", {
                    obj: this.taskModel,
                    prms: this.prms,
                  });
                }
              } else {
                this.datahandleLoading = false;
              }
            });
          }
          // else if(ltErrs.length){
          //   this.datahandleLoading = false;
          //     ltValid=false;
          //     //let msg=;
          //     //msg+=ltErrs.join('<br/>')
          //     this.$bvToast.toast(
          //     `Хүчин зүйлийн * тэмдэглэгээтэй заавал бөглөх талбаруудыг бөглөнө үү!`,

          //     {
          //       title: "заавал бөглөх талбар",
          //       autoHideDelay: 3000,
          //       appendToast: true,
          //       variant: "warning",
          //       toaster: "b-toaster-bottom-left",
          //     }
          //   );
          //   }
          else {
            this.datahandleLoading = false;
            this.$bvToast.toast(
              `* тэмдэглэгээтэй заавал бөглөх талбаруудыг бөглөнө үү!`,
              {
                title: "заавал бөглөх талбар",
                autoHideDelay: 3000,
                appendToast: true,
                variant: "warning",
                toaster: "b-toaster-bottom-left",
              }
            );
          }
        });
      }
    },
    visibleChanged(e) {
      if (!e) {
        if (this.directClose) {
          this.$emit("on-task-posted", {
            obj: this.taskModel,
            prms: this.prms,
          });
          Object.assign(this.$data, this.$options.data());
        }
        Object.assign(this.$data, this.$options.data());
        this.$emit("on-edit-close");
      }
    },
    editClosed() {
      this.taskEdit.show = false;
      this.taskEdit.id = 0;
    },
    editShow(e) {
      this.taskEdit.id = e.id;
      this.taskEdit.objectTypeId = e.objectTypeId;
      this.taskEdit.projectId = e.projectId;
      if (e.mode == 2) {
        this.taskEdit.boxId = e.boxId;
        this.taskEdit.parentId = this.taskDetail.id;
        this.taskEdit.parentTask = this.taskDetail;
      }
      this.taskEdit.render = true;
      this.$nextTick(function() {
        this.taskEdit.show = true;
      });
    },
    taskPosted(e) {
      if (e.prms.boxId != undefined) {
        if (this.$refs["box_" + e.prms.boxId].length > 0) {
          this.$refs["box_" + e.prms.boxId][0].reInit(e);
        }
        this.editClosed();
      } else {
        //else ooroo ooriigoo zasaagui
        //this.editClosed();
        //this.init();
      }
    },
    showFinder(e, mode) {
      if (mode != undefined && mode > 0) {
        this.mediaFinder.mode = mode;
      }
      this.mediaFinder.obj = e;
      this.mediaFinder.show = true;
    },
    createMapMarkerForce(t) {
      this.googleMapMaker = [
        {
          position: {
            lat: parseFloat(t.lat),
            lng: parseFloat(t.lng),
          },
        },
      ];
    },
    createMapMarker(e) {
      this.googleMapMaker = [
        {
          position: {
            lat: e.latLng.lat(),
            lng: e.latLng.lng(),
          },
        },
      ];

      this.$data["taskModel"]["lat"] = e.latLng.lat().toString();
      this.$data["taskModel"]["lng"] = e.latLng.lng().toString();
    },

    createMapMarkers(field, e) {
      //console.log(field);
      let poses = JSON.parse(this.$data["taskModel"][field]);
      if (poses == null || poses == undefined) {
        poses = [];
      }
      poses.push({
        position: {
          lat: e.latLng.lat(),
          lng: e.latLng.lng(),
        },
      });
      this.$data["taskModel"][field] = JSON.stringify(poses);
      //console.log(this.$data["taskModel"][field]);
    },

    setTransferOptions(id) {
      getColumnListByTaskId({
        params: { taskId: id },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.transferOptions.taskColumns = res.data.columns;
          this.transferOptions.canFinishTask = res.data.canFinish;
          this.transferOptions.canReturnTask = res.data.canReturn;

          this.transferOptions.canChangeProject = res.data.canProjectChange;

          let currentColumn = this.transferOptions.taskColumns.filter(
            (x) => x.direction == 1
          );
          if (currentColumn.length > 0) {
            this.transferOptions.isFirstColumn = currentColumn[0].ord == 1;
          }
          let _skipColumn = this.transferOptions.taskColumns.filter(
            (x) => x.skipAfterColumnId != 0 && x.direction == 1
          );
          if (_skipColumn.length > 0) {
            this.transferOptions.skipAfterColumn.id =
              _skipColumn[0].skipAfterColumnId;

            if (
              this.transferOptions.taskColumns.filter(
                (x) => x.id == this.transferOptions.skipAfterColumn.id
              ).length > 0
            ) {
              this.transferOptions.skipAfterColumn.name = this.transferOptions.taskColumns.filter(
                (x) => x.id == this.transferOptions.skipAfterColumn.id
              )[0].title;
            }
          }

          this.openOrAssignColumn(id, 1);
        }
      });
    },
    openOrAssignColumn(id, mode) {
      this.actionDialog.mode = mode;
      this.actionDialog.id = id;
      this.actionDialog.show = true;
    },

    columnChange(e) {
      this.taskModel.currentColumnId = e;
      this.taskModel.pinnedUsers = [];
      this.userSelected = [];
      request({
        api: { url: "Column/GetUserInColumn", method: "GET" },
        params: {
          columnId: e,
        },
        store: this.$store,
      }).then((res) => {
        this.departs = res.data.departs;
        this.users = res.data.users;
        if (this.users.length > 0) {
          let uids = this.users
            .filter((u) => u.flag == 1)
            .map(function(u) {
              return u.userId;
            });
          //console.log(uids)
          if (uids.length > 0) {
            this.userSelected = uids;
            this.taskModel.pinnedUsers = uids;
          } else {
            let me = this.users.filter(
              (p) => p.userId == this.$store.state.user.userId
            );
            if (me.length > 0) {
              this.userSelected = [this.$store.state.user.userId];
              this.taskModel.pinnedUsers = [this.$store.state.user.userId];
            } else {
              //this.userSelected = [this.users[0].userId];
              this.userSelected = [];
              //this.taskModel.pinnedUsers = [this.users[0].userId];
              this.taskModel.pinnedUsers = [];
            }
          }

          if (
            this.userSelected.filter((x) => x == this.$store.state.user.userId)
              .length == 0
          ) {
            if (
              this.users.filter(
                (x) => x.userId == this.$store.state.user.userId
              ).length > 0
            ) {
              this.userSelected.push(this.$store.state.user.userId);
              //this.taskModel.pinnedUsers.push(this.$store.state.user.userId)
            }
          }
        }
        this.showSpin = false;
      });
    },
    userChange(e) {
      this.taskModel.pinnedUsers = e;
    },

    //# hereglogch oldog hesegtei holbootoi
    createdUserChanged(e) {
      this.createdUser.mode = e;
    },
    createdUserFind(field) {
      if (this.createdUser.mode == "1") {
        request({
          api: { url: "Hr/GetUsersByLoginName", method: "GET" },
          params: {
            loginName: this.createdUser.value,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.createdUserFindAfter(res, field);
          }
        });
      } else if (this.createdUser.mode == "2") {
        request({
          api: { url: "Hr/GetUsersByRegister", method: "GET" },
          params: {
            register: this.createdUser.value,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.createdUserFindAfter(res, field);
          }
        });
      } else if (this.createdUser.mode == "3") {
        request({
          api: { url: "Hr/GetUsersByFirstName", method: "GET" },
          params: {
            firstName: this.createdUser.value,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.createdUserFindAfter(res, field);
          }
        });
      }
    },
    createdUserFindAfter(res, field) {
      this.createdUser.list = res.data.users;

      if (field != undefined) {
        this.createdUser.field = field;
      }

      if (this.createdUser.list.length > 0) {
        if (this.createdUser.list.length == 1) {
          this.assignScndUserId(res.data.users[0]);
        } else {
          this.createdUser.modal = true;
        }
      } else {
        Notification.success({
          message: `${this.createdUser.value}: хайсан утгаар хэрэглэгч олдсонгүй`,
          duration: 5000,
        });
      }
    },
    assignScndUserId(task) {
      if (
        this.createdUser.field != null &&
        this.createdUser.field.key != null &&
        this.createdUser.field.key != ""
      ) {
        this.$data["taskModel"][this.createdUser.field.key] = task.id;
      } else {
        this.$data["taskModel"]["secondUserId"] = task.userId;
      }

      this.$data["taskModel"]["langCode"] = task.lastName;
      this.$data["taskModel"]["task"] = task.firstName;
      Notification.success({
        message: `${task.userName} кодтой ${task.firstName}-г сонголоо`,
        duration: 5000,
      });
    },
    createdUserRemove() {
      this.createdUser.value = "";
      this.createdUser.field = null;
      this.$data["taskModel"]["secondUserId"] = null;
      this.$data["taskModel"]["langCode"] = null;
      this.$data["taskModel"]["task"] = null;
    },
    getProjId(ot) {
      //return "";
      let projs = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == parseInt(ot, 10)
      );
      if (projs.length > 0) return "sysProjectTag_" + projs[0].id;
      else return "";
    },
    erpCourseSourceChanged(e) {
      let _src = [];
      if (this.prms.objectTypeId == 115) {
        _src = this.erpGolomt.sources.filter((x) => x.trainingId == e);
      } else if (this.prms.objectTypeId == 396) {
        _src = this.erpGolomt.sources.filter((x) => x.teacherId == e);
      }

      if (_src.length > 0) {
        if (this.prms.objectTypeId == 115) {
          this.$data["taskModel"]["task"] = _src[0]["trainingName"];
          this.$data["taskModel"]["mobile"] = _src[0]["trainingId"];
        } else if (this.prms.objectTypeId == 396) {
          this.$data["taskModel"]["task"] = _src[0]["teacherName"];
          this.$data["taskModel"]["mobile"] = _src[0]["teacherId"];
        }
      }
    },

    locTypeAssignTaskOther(e) {
      this.$data["taskModel"][e.field] = e.label;
    },
    locTypeAssignTask(e) {
      this.$data["taskModel"]["task"] = e.label;
    },

    //# ASSET MANAGMENT
    assetChanged(e) {
      // //console.log(e);
      this.$data["taskModel"]["organizationTaskId"] = e.locationId;
      this.$data["taskModel"]["secondOrganizationTaskId"] = e.assetId;
    },
  },
};
</script>
<style lang="less">
.core-edit-side-header > strong {
  display: block;
  width: 100%;
}
.el-form-item__label {
  line-height: 1.2;
}
.el-form {
  &.el-form--label-top {
    .ltfs {
      .el-form-item {
        margin-bottom: 0;
        .el-form-item__content {
          padding: 10px;
        }
      }
    }
    .el-form-item {
      .el-form-item__label {
        margin-bottom: 0;
        padding-bottom: 0;
      }
    }
  }
}
</style>
